import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import { g as t, j as e, k as r, c as n, u as i, a as o, b as a, _ as s, d as u, e as c, f as l, h as p, m as h, i as f } from "./_commonjsHelpers-b0e8727a.js";
import d, { Fragment as v } from "react";
import { P as y } from "./index-f450c016.js";
import { s as g } from "./style-inject.es-1f59c1d0.js";
import { r as m, S as _, i as b, a as w } from "./debounce-c95729f2.js";
import { t as S } from "./throttle-3ec7226e.js";
import { combineReducers as x } from "redux";
import { connect as E, Provider as I } from "react-redux";
import { c as k, a as L, z as O, P as T, M as z, V as j, B as P, b as R, u as C, v as M, w as A, d as D, l as q, e as B, f as F, A as U, g as V, h as N, i as H, q as K, j as W, T as G, k as J, s as Z, m as Y, t as X, n as $, C as Q, S as tt, G as et, o as rt, p as nt, r as it, x as ot, y as at, D as st, E as ut, F as ct, H as lt, U as pt, I as ht, J as ft, K as dt, L as vt, N as yt, O as gt, Q as mt, R as _t, W as bt, X as wt, Y as St, Z as xt, _ as Et, $ as It, a0 as kt, a1 as Lt, a2 as Ot, a3 as Tt, a4 as zt, a5 as jt, a6 as Pt, a7 as Rt, a8 as Ct, a9 as Mt, aa as At, ab as Dt, ac as qt, ad as Bt, ae as Ft, af as Ut, ag as Vt, ah as Nt, ai as Ht, aj as Kt, ak as Wt, al as Gt, am as Jt, an as Zt, ao as Yt, ap as Xt, aq as $t, ar as Qt, as as te, at as ee, au as re, av as ne, aw as ie, ax as oe, ay as ae, az as se } from "./index-30b694ea.js";
import ue, { BaseControl as ce, Popup as le, Marker as pe } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { Container as he, Application as fe, Texture as de } from "pixi.js";
import { h as ve, V as ye, a as ge, b as me, w as _e, c as be, d as we } from "./map-colors-062a97a5.js";
import { G as Se } from "./style-a86d5d52.js";
var xe = {
  id: y.string.isRequired,
  url: y.string,
  data: y.object,
  color: y.string,
  type: y.oneOf(["geojson", "pelagos", void 0]),
  layerTemporalExtents: y.arrayOf(y.arrayOf(y.number)),
  fitBoundsOnLoad: y.bool
},
    Ee = {
  id: y.string.isRequired,
  tilesetId: y.string,
  subtype: y.string,
  visible: y.bool,
  hue: y.number,
  opacity: y.number,
  filters: y.arrayOf(y.shape({
    hue: y.number,
    filterValues: y.object
  })),
  header: y.shape({
    endpoints: y.object,
    colsByName: y.object,
    temporalExtents: y.arrayOf(y.arrayOf(y.number)),
    temporalExtentsLess: y.bool
  }).isRequired,
  interactive: y.bool
},
    Ie = {
  id: y.string,
  visible: y.bool
},
    ke = {
  id: y.string.isRequired,
  visible: y.bool,
  selected: y.bool,
  selectedFeatures: y.shape({
    field: y.string,
    values: y.arrayOf(y.string)
  }),
  highlighted: y.bool,
  higlightedFeatures: y.shape({
    field: y.string,
    values: y.arrayOf(y.string)
  }),
  opacity: y.number,
  color: y.string,
  showLabels: y.bool,
  interactive: y.bool,
  filters: y.arrayOf(y.arrayOf(y.string)),
  isCustom: y.bool,
  subtype: y.oneOf([void 0, "geojson", "raster"]),
  url: y.string,
  data: y.object,
  gl: y.object
},
    Le = {
  content: y.node,
  latitude: y.number.isRequired,
  longitude: y.number.isRequired
},
    Oe = {
  zoom: y.number,
  center: y.arrayOf(y.number)
};

function Te(t, e) {
  return t === e;
}

var ze = function (t) {
  for (var e = arguments.length, r = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
    r[n - 1] = arguments[n];
  }

  return function () {
    for (var e = arguments.length, n = Array(e), i = 0; i < e; i++) {
      n[i] = arguments[i];
    }

    var o = 0,
        a = n.pop(),
        s = function (t) {
      var e = Array.isArray(t[0]) ? t[0] : t;

      if (!e.every(function (t) {
        return "function" == typeof t;
      })) {
        var r = e.map(function (t) {
          return typeof t;
        }).join(", ");
        throw new Error("Selector creators expect all input-selectors to be functions, instead received the following types: [" + r + "]");
      }

      return e;
    }(n),
        u = t.apply(void 0, [function () {
      return o++, a.apply(null, arguments);
    }].concat(r)),
        c = t(function () {
      for (var t = [], e = s.length, r = 0; r < e; r++) {
        t.push(s[r].apply(null, arguments));
      }

      return u.apply(null, t);
    });

    return c.resultFunc = a, c.dependencies = s, c.recomputations = function () {
      return o;
    }, c.resetRecomputations = function () {
      return o = 0;
    }, c;
  };
}(function (t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Te,
      r = null,
      n = null;
  return function () {
    return function (t, e, r) {
      if (null === e || null === r || e.length !== r.length) return !1;

      for (var n = e.length, i = 0; i < n; i++) {
        if (!t(e[i], r[i])) return !1;
      }

      return !0;
    }(e, r, arguments) || (n = t.apply(null, arguments)), r = arguments, n;
  };
}),
    je = 5,
    Pe = 1 << je,
    Re = Pe - 1,
    Ce = {};

function Me(t) {
  t && (t.value = !0);
}

function Ae() {}

function De(t) {
  return void 0 === t.size && (t.size = t.__iterate(Be)), t.size;
}

function qe(t, e) {
  if ("number" != typeof e) {
    var r = e >>> 0;
    if ("" + r !== e || 4294967295 === r) return NaN;
    e = r;
  }

  return e < 0 ? De(t) + e : e;
}

function Be() {
  return !0;
}

function Fe(t, e, r) {
  return (0 === t && !He(t) || void 0 !== r && t <= -r) && (void 0 === e || void 0 !== r && e >= r);
}

function Ue(t, e) {
  return Ne(t, e, 0);
}

function Ve(t, e) {
  return Ne(t, e, e);
}

function Ne(t, e, r) {
  return void 0 === t ? r : He(t) ? e === 1 / 0 ? e : 0 | Math.max(0, e + t) : void 0 === e || e === t ? t : 0 | Math.min(e, t);
}

function He(t) {
  return t < 0 || 0 === t && 1 / t == -1 / 0;
}

var Ke = "@@__IMMUTABLE_ITERABLE__@@";

function We(t) {
  return Boolean(t && t[Ke]);
}

var Ge = "@@__IMMUTABLE_KEYED__@@";

function Je(t) {
  return Boolean(t && t[Ge]);
}

var Ze = "@@__IMMUTABLE_INDEXED__@@";

function Ye(t) {
  return Boolean(t && t[Ze]);
}

function Xe(t) {
  return Je(t) || Ye(t);
}

var $e = function $e(t) {
  return We(t) ? t : Er(t);
},
    Qe = function (t) {
  function e(t) {
    return Je(t) ? t : Ir(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}($e),
    tr = function (t) {
  function e(t) {
    return Ye(t) ? t : kr(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}($e),
    er = function (t) {
  function e(t) {
    return We(t) && !Xe(t) ? t : Lr(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e;
}($e);

$e.Keyed = Qe, $e.Indexed = tr, $e.Set = er;
var rr = "@@__IMMUTABLE_SEQ__@@";

function nr(t) {
  return Boolean(t && t[rr]);
}

var ir = "@@__IMMUTABLE_RECORD__@@";

function or(t) {
  return Boolean(t && t[ir]);
}

function ar(t) {
  return We(t) || or(t);
}

var sr = "@@__IMMUTABLE_ORDERED__@@";

function ur(t) {
  return Boolean(t && t[sr]);
}

var cr = 0,
    lr = 1,
    pr = 2,
    hr = "function" == typeof Symbol && Symbol.iterator,
    fr = "@@iterator",
    dr = hr || fr,
    vr = function vr(t) {
  this.next = t;
};

function yr(t, e, r, n) {
  var i = 0 === t ? e : 1 === t ? r : [e, r];
  return n ? n.value = i : n = {
    value: i,
    done: !1
  }, n;
}

function gr() {
  return {
    value: void 0,
    done: !0
  };
}

function mr(t) {
  return !!wr(t);
}

function _r(t) {
  return t && "function" == typeof t.next;
}

function br(t) {
  var e = wr(t);
  return e && e.call(t);
}

function wr(t) {
  var e = t && (hr && t[hr] || t[fr]);
  if ("function" == typeof e) return e;
}

vr.prototype.toString = function () {
  return "[Iterator]";
}, vr.KEYS = cr, vr.VALUES = lr, vr.ENTRIES = pr, vr.prototype.inspect = vr.prototype.toSource = function () {
  return this.toString();
}, vr.prototype[dr] = function () {
  return this;
};
var Sr = Object.prototype.hasOwnProperty;

function xr(t) {
  return !(!Array.isArray(t) && "string" != typeof t) || t && "object" == typeof t && Number.isInteger(t.length) && t.length >= 0 && (0 === t.length ? 1 === Object.keys(t).length : t.hasOwnProperty(t.length - 1));
}

var Er = function (t) {
  function e(t) {
    return null == t ? Pr() : ar(t) ? t.toSeq() : function (t) {
      var e = Mr(t);
      if (e) return e;
      if ("object" == typeof t) return new Tr(t);
      throw new TypeError("Expected Array or collection object of values, or keyed object: " + t);
    }(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toSeq = function () {
    return this;
  }, e.prototype.toString = function () {
    return this.__toString("Seq {", "}");
  }, e.prototype.cacheResult = function () {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, e.prototype.__iterate = function (t, e) {
    var r = this._cache;

    if (r) {
      for (var n = r.length, i = 0; i !== n;) {
        var o = r[e ? n - ++i : i++];
        if (!1 === t(o[1], o[0], this)) break;
      }

      return i;
    }

    return this.__iterateUncached(t, e);
  }, e.prototype.__iterator = function (t, e) {
    var r = this._cache;

    if (r) {
      var n = r.length,
          i = 0;
      return new vr(function () {
        if (i === n) return {
          value: void 0,
          done: !0
        };
        var o = r[e ? n - ++i : i++];
        return yr(t, o[0], o[1]);
      });
    }

    return this.__iteratorUncached(t, e);
  }, e;
}($e),
    Ir = function (t) {
  function e(t) {
    return null == t ? Pr().toKeyedSeq() : We(t) ? Je(t) ? t.toSeq() : t.fromEntrySeq() : or(t) ? t.toSeq() : Rr(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toKeyedSeq = function () {
    return this;
  }, e;
}(Er),
    kr = function (t) {
  function e(t) {
    return null == t ? Pr() : We(t) ? Je(t) ? t.entrySeq() : t.toIndexedSeq() : or(t) ? t.toSeq().entrySeq() : Cr(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return e(arguments);
  }, e.prototype.toIndexedSeq = function () {
    return this;
  }, e.prototype.toString = function () {
    return this.__toString("Seq [", "]");
  }, e;
}(Er),
    Lr = function (t) {
  function e(t) {
    return (We(t) && !Xe(t) ? t : kr(t)).toSetSeq();
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return e(arguments);
  }, e.prototype.toSetSeq = function () {
    return this;
  }, e;
}(Er);

Er.isSeq = nr, Er.Keyed = Ir, Er.Set = Lr, Er.Indexed = kr, Er.prototype[rr] = !0;

var Or = function (t) {
  function e(t) {
    this._array = t, this.size = t.length;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t, e) {
    return this.has(t) ? this._array[qe(this, t)] : e;
  }, e.prototype.__iterate = function (t, e) {
    for (var r = this._array, n = r.length, i = 0; i !== n;) {
      var o = e ? n - ++i : i++;
      if (!1 === t(r[o], o, this)) break;
    }

    return i;
  }, e.prototype.__iterator = function (t, e) {
    var r = this._array,
        n = r.length,
        i = 0;
    return new vr(function () {
      if (i === n) return {
        value: void 0,
        done: !0
      };
      var o = e ? n - ++i : i++;
      return yr(t, o, r[o]);
    });
  }, e;
}(kr),
    Tr = function (t) {
  function e(t) {
    var e = Object.keys(t);
    this._object = t, this._keys = e, this.size = e.length;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t, e) {
    return void 0 === e || this.has(t) ? this._object[t] : e;
  }, e.prototype.has = function (t) {
    return Sr.call(this._object, t);
  }, e.prototype.__iterate = function (t, e) {
    for (var r = this._object, n = this._keys, i = n.length, o = 0; o !== i;) {
      var a = n[e ? i - ++o : o++];
      if (!1 === t(r[a], a, this)) break;
    }

    return o;
  }, e.prototype.__iterator = function (t, e) {
    var r = this._object,
        n = this._keys,
        i = n.length,
        o = 0;
    return new vr(function () {
      if (o === i) return {
        value: void 0,
        done: !0
      };
      var a = n[e ? i - ++o : o++];
      return yr(t, a, r[a]);
    });
  }, e;
}(Ir);

Tr.prototype[sr] = !0;

var zr,
    jr = function (t) {
  function e(t) {
    this._collection = t, this.size = t.length || t.size;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.__iterateUncached = function (t, e) {
    if (e) return this.cacheResult().__iterate(t, e);
    var r = br(this._collection),
        n = 0;
    if (_r(r)) for (var i; !(i = r.next()).done && !1 !== t(i.value, n++, this);) {
      ;
    }
    return n;
  }, e.prototype.__iteratorUncached = function (t, e) {
    if (e) return this.cacheResult().__iterator(t, e);
    var r = br(this._collection);
    if (!_r(r)) return new vr(gr);
    var n = 0;
    return new vr(function () {
      var e = r.next();
      return e.done ? e : yr(t, n++, e.value);
    });
  }, e;
}(kr);

function Pr() {
  return zr || (zr = new Or([]));
}

function Rr(t) {
  var e = Array.isArray(t) ? new Or(t) : mr(t) ? new jr(t) : void 0;
  if (e) return e.fromEntrySeq();
  if ("object" == typeof t) return new Tr(t);
  throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + t);
}

function Cr(t) {
  var e = Mr(t);
  if (e) return e;
  throw new TypeError("Expected Array or collection object of values: " + t);
}

function Mr(t) {
  return xr(t) ? new Or(t) : mr(t) ? new jr(t) : void 0;
}

var Ar = "@@__IMMUTABLE_MAP__@@";

function Dr(t) {
  return Boolean(t && t[Ar]);
}

function qr(t) {
  return Dr(t) && ur(t);
}

function Br(t) {
  return Boolean(t && "function" == typeof t.equals && "function" == typeof t.hashCode);
}

function Fr(t, e) {
  if (t === e || t != t && e != e) return !0;
  if (!t || !e) return !1;

  if ("function" == typeof t.valueOf && "function" == typeof e.valueOf) {
    if ((t = t.valueOf()) === (e = e.valueOf()) || t != t && e != e) return !0;
    if (!t || !e) return !1;
  }

  return !!(Br(t) && Br(e) && t.equals(e));
}

var Ur = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function (t, e) {
  var r = 65535 & (t |= 0),
      n = 65535 & (e |= 0);
  return r * n + ((t >>> 16) * n + r * (e >>> 16) << 16 >>> 0) | 0;
};

function Vr(t) {
  return t >>> 1 & 1073741824 | 3221225471 & t;
}

var Nr = Object.prototype.valueOf;

function Hr(t) {
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;

    case "number":
      return function (t) {
        if (t != t || t === 1 / 0) return 0;
        var e = 0 | t;
        e !== t && (e ^= 4294967295 * t);

        for (; t > 4294967295;) {
          e ^= t /= 4294967295;
        }

        return Vr(e);
      }(t);

    case "string":
      return t.length > $r ? function (t) {
        var e = en[t];
        void 0 === e && (e = Kr(t), tn === Qr && (tn = 0, en = {}), tn++, en[t] = e);
        return e;
      }(t) : Kr(t);

    case "object":
    case "function":
      return null === t ? 1108378658 : "function" == typeof t.hashCode ? Vr(t.hashCode(t)) : (t.valueOf !== Nr && "function" == typeof t.valueOf && (t = t.valueOf(t)), function (t) {
        var e;
        if (Zr && void 0 !== (e = Jr.get(t))) return e;
        if (void 0 !== (e = t[Xr])) return e;

        if (!Gr) {
          if (void 0 !== (e = t.propertyIsEnumerable && t.propertyIsEnumerable[Xr])) return e;
          if (void 0 !== (e = function (t) {
            if (t && t.nodeType > 0) switch (t.nodeType) {
              case 1:
                return t.uniqueID;

              case 9:
                return t.documentElement && t.documentElement.uniqueID;
            }
          }(t))) return e;
        }

        e = ++Yr, 1073741824 & Yr && (Yr = 0);
        if (Zr) Jr.set(t, e);else {
          if (void 0 !== Wr && !1 === Wr(t)) throw new Error("Non-extensible objects are not allowed as keys.");
          if (Gr) Object.defineProperty(t, Xr, {
            enumerable: !1,
            configurable: !1,
            writable: !1,
            value: e
          });else if (void 0 !== t.propertyIsEnumerable && t.propertyIsEnumerable === t.constructor.prototype.propertyIsEnumerable) t.propertyIsEnumerable = function () {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
          }, t.propertyIsEnumerable[Xr] = e;else {
            if (void 0 === t.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
            t[Xr] = e;
          }
        }
        return e;
      }(t));

    case "undefined":
      return 1108378659;

    default:
      if ("function" == typeof t.toString) return Kr(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}

function Kr(t) {
  for (var e = 0, r = 0; r < t.length; r++) {
    e = 31 * e + t.charCodeAt(r) | 0;
  }

  return Vr(e);
}

var Wr = Object.isExtensible,
    Gr = function () {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch (t) {
    return !1;
  }
}();

var Jr,
    Zr = "function" == typeof WeakMap;
Zr && (Jr = new WeakMap());
var Yr = 0,
    Xr = "__immutablehash__";
"function" == typeof Symbol && (Xr = Symbol(Xr));

var $r = 16,
    Qr = 255,
    tn = 0,
    en = {},
    rn = function (t) {
  function e(t, e) {
    this._iter = t, this._useKeys = e, this.size = t.size;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.get = function (t, e) {
    return this._iter.get(t, e);
  }, e.prototype.has = function (t) {
    return this._iter.has(t);
  }, e.prototype.valueSeq = function () {
    return this._iter.valueSeq();
  }, e.prototype.reverse = function () {
    var t = this,
        e = cn(this, !0);
    return this._useKeys || (e.valueSeq = function () {
      return t._iter.toSeq().reverse();
    }), e;
  }, e.prototype.map = function (t, e) {
    var r = this,
        n = un(this, t, e);
    return this._useKeys || (n.valueSeq = function () {
      return r._iter.toSeq().map(t, e);
    }), n;
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    return this._iter.__iterate(function (e, n) {
      return t(e, n, r);
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    return this._iter.__iterator(t, e);
  }, e;
}(Ir);

rn.prototype[sr] = !0;

var nn = function (t) {
  function e(t) {
    this._iter = t, this.size = t.size;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.includes = function (t) {
    return this._iter.includes(t);
  }, e.prototype.__iterate = function (t, e) {
    var r = this,
        n = 0;
    return e && De(this), this._iter.__iterate(function (i) {
      return t(i, e ? r.size - ++n : n++, r);
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    var r = this,
        n = this._iter.__iterator(lr, e),
        i = 0;

    return e && De(this), new vr(function () {
      var o = n.next();
      return o.done ? o : yr(t, e ? r.size - ++i : i++, o.value, o);
    });
  }, e;
}(kr),
    on = function (t) {
  function e(t) {
    this._iter = t, this.size = t.size;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.has = function (t) {
    return this._iter.includes(t);
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    return this._iter.__iterate(function (e) {
      return t(e, e, r);
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    var r = this._iter.__iterator(lr, e);

    return new vr(function () {
      var e = r.next();
      return e.done ? e : yr(t, e.value, e.value, e);
    });
  }, e;
}(Lr),
    an = function (t) {
  function e(t) {
    this._iter = t, this.size = t.size;
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.entrySeq = function () {
    return this._iter.toSeq();
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    return this._iter.__iterate(function (e) {
      if (e) {
        _n(e);

        var n = We(e);
        return t(n ? e.get(1) : e[1], n ? e.get(0) : e[0], r);
      }
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    var r = this._iter.__iterator(lr, e);

    return new vr(function () {
      for (;;) {
        var e = r.next();
        if (e.done) return e;
        var n = e.value;

        if (n) {
          _n(n);

          var i = We(n);
          return yr(t, i ? n.get(0) : n[0], i ? n.get(1) : n[1], e);
        }
      }
    });
  }, e;
}(Ir);

function sn(t) {
  var e = wn(t);
  return e._iter = t, e.size = t.size, e.flip = function () {
    return t;
  }, e.reverse = function () {
    var e = t.reverse.apply(this);
    return e.flip = function () {
      return t.reverse();
    }, e;
  }, e.has = function (e) {
    return t.includes(e);
  }, e.includes = function (e) {
    return t.has(e);
  }, e.cacheResult = Sn, e.__iterateUncached = function (e, r) {
    var n = this;
    return t.__iterate(function (t, r) {
      return !1 !== e(r, t, n);
    }, r);
  }, e.__iteratorUncached = function (e, r) {
    if (e === pr) {
      var n = t.__iterator(e, r);

      return new vr(function () {
        var t = n.next();

        if (!t.done) {
          var e = t.value[0];
          t.value[0] = t.value[1], t.value[1] = e;
        }

        return t;
      });
    }

    return t.__iterator(e === lr ? cr : lr, r);
  }, e;
}

function un(t, e, r) {
  var n = wn(t);
  return n.size = t.size, n.has = function (e) {
    return t.has(e);
  }, n.get = function (n, i) {
    var o = t.get(n, Ce);
    return o === Ce ? i : e.call(r, o, n, t);
  }, n.__iterateUncached = function (n, i) {
    var o = this;
    return t.__iterate(function (t, i, a) {
      return !1 !== n(e.call(r, t, i, a), i, o);
    }, i);
  }, n.__iteratorUncached = function (n, i) {
    var o = t.__iterator(pr, i);

    return new vr(function () {
      var i = o.next();
      if (i.done) return i;
      var a = i.value,
          s = a[0];
      return yr(n, s, e.call(r, a[1], s, t), i);
    });
  }, n;
}

function cn(t, e) {
  var r = this,
      n = wn(t);
  return n._iter = t, n.size = t.size, n.reverse = function () {
    return t;
  }, t.flip && (n.flip = function () {
    var e = sn(t);
    return e.reverse = function () {
      return t.flip();
    }, e;
  }), n.get = function (r, n) {
    return t.get(e ? r : -1 - r, n);
  }, n.has = function (r) {
    return t.has(e ? r : -1 - r);
  }, n.includes = function (e) {
    return t.includes(e);
  }, n.cacheResult = Sn, n.__iterate = function (r, n) {
    var i = this,
        o = 0;
    return n && De(t), t.__iterate(function (t, a) {
      return r(t, e ? a : n ? i.size - ++o : o++, i);
    }, !n);
  }, n.__iterator = function (n, i) {
    var o = 0;
    i && De(t);

    var a = t.__iterator(pr, !i);

    return new vr(function () {
      var t = a.next();
      if (t.done) return t;
      var s = t.value;
      return yr(n, e ? s[0] : i ? r.size - ++o : o++, s[1], t);
    });
  }, n;
}

function ln(t, e, r, n) {
  var i = wn(t);
  return n && (i.has = function (n) {
    var i = t.get(n, Ce);
    return i !== Ce && !!e.call(r, i, n, t);
  }, i.get = function (n, i) {
    var o = t.get(n, Ce);
    return o !== Ce && e.call(r, o, n, t) ? o : i;
  }), i.__iterateUncached = function (i, o) {
    var a = this,
        s = 0;
    return t.__iterate(function (t, o, u) {
      if (e.call(r, t, o, u)) return s++, i(t, n ? o : s - 1, a);
    }, o), s;
  }, i.__iteratorUncached = function (i, o) {
    var a = t.__iterator(pr, o),
        s = 0;

    return new vr(function () {
      for (;;) {
        var o = a.next();
        if (o.done) return o;
        var u = o.value,
            c = u[0],
            l = u[1];
        if (e.call(r, l, c, t)) return yr(i, n ? c : s++, l, o);
      }
    });
  }, i;
}

function pn(t, e, r, n) {
  var i = t.size;
  if (Fe(e, r, i)) return t;
  var o = Ue(e, i),
      a = Ve(r, i);
  if (o != o || a != a) return pn(t.toSeq().cacheResult(), e, r, n);
  var s,
      u = a - o;
  u == u && (s = u < 0 ? 0 : u);
  var c = wn(t);
  return c.size = 0 === s ? s : t.size && s || void 0, !n && nr(t) && s >= 0 && (c.get = function (e, r) {
    return (e = qe(this, e)) >= 0 && e < s ? t.get(e + o, r) : r;
  }), c.__iterateUncached = function (e, r) {
    var i = this;
    if (0 === s) return 0;
    if (r) return this.cacheResult().__iterate(e, r);
    var a = 0,
        u = !0,
        c = 0;
    return t.__iterate(function (t, r) {
      if (!u || !(u = a++ < o)) return c++, !1 !== e(t, n ? r : c - 1, i) && c !== s;
    }), c;
  }, c.__iteratorUncached = function (e, r) {
    if (0 !== s && r) return this.cacheResult().__iterator(e, r);
    if (0 === s) return new vr(gr);

    var i = t.__iterator(e, r),
        a = 0,
        u = 0;

    return new vr(function () {
      for (; a++ < o;) {
        i.next();
      }

      if (++u > s) return {
        value: void 0,
        done: !0
      };
      var t = i.next();
      return n || e === lr || t.done ? t : yr(e, u - 1, e === cr ? void 0 : t.value[1], t);
    });
  }, c;
}

function hn(t, e, r, n) {
  var i = wn(t);
  return i.__iterateUncached = function (i, o) {
    var a = this;
    if (o) return this.cacheResult().__iterate(i, o);
    var s = !0,
        u = 0;
    return t.__iterate(function (t, o, c) {
      if (!s || !(s = e.call(r, t, o, c))) return u++, i(t, n ? o : u - 1, a);
    }), u;
  }, i.__iteratorUncached = function (i, o) {
    var a = this;
    if (o) return this.cacheResult().__iterator(i, o);

    var s = t.__iterator(pr, o),
        u = !0,
        c = 0;

    return new vr(function () {
      var t, o, l;

      do {
        if ((t = s.next()).done) return n || i === lr ? t : yr(i, c++, i === cr ? void 0 : t.value[1], t);
        var p = t.value;
        o = p[0], l = p[1], u && (u = e.call(r, l, o, a));
      } while (u);

      return i === pr ? t : yr(i, o, l, t);
    });
  }, i;
}

function fn(t, e, r) {
  var n = wn(t);
  return n.__iterateUncached = function (i, o) {
    if (o) return this.cacheResult().__iterate(i, o);
    var a = 0,
        s = !1;
    return function t(u, c) {
      u.__iterate(function (o, u) {
        return (!e || c < e) && We(o) ? t(o, c + 1) : (a++, !1 === i(o, r ? u : a - 1, n) && (s = !0)), !s;
      }, o);
    }(t, 0), a;
  }, n.__iteratorUncached = function (n, i) {
    if (i) return this.cacheResult().__iterator(n, i);

    var o = t.__iterator(n, i),
        a = [],
        s = 0;

    return new vr(function () {
      for (; o;) {
        var t = o.next();

        if (!1 === t.done) {
          var u = t.value;
          if (n === pr && (u = u[1]), e && !(a.length < e) || !We(u)) return r ? t : yr(n, s++, u, t);
          a.push(o), o = u.__iterator(n, i);
        } else o = a.pop();
      }

      return {
        value: void 0,
        done: !0
      };
    });
  }, n;
}

function dn(t, e, r) {
  e || (e = xn);
  var n = Je(t),
      i = 0,
      o = t.toSeq().map(function (e, n) {
    return [n, e, i++, r ? r(e, n, t) : e];
  }).valueSeq().toArray();
  return o.sort(function (t, r) {
    return e(t[3], r[3]) || t[2] - r[2];
  }).forEach(n ? function (t, e) {
    o[e].length = 2;
  } : function (t, e) {
    o[e] = t[1];
  }), n ? Ir(o) : Ye(t) ? kr(o) : Lr(o);
}

function vn(t, e, r) {
  if (e || (e = xn), r) {
    var n = t.toSeq().map(function (e, n) {
      return [e, r(e, n, t)];
    }).reduce(function (t, r) {
      return yn(e, t[1], r[1]) ? r : t;
    });
    return n && n[0];
  }

  return t.reduce(function (t, r) {
    return yn(e, t, r) ? r : t;
  });
}

function yn(t, e, r) {
  var n = t(r, e);
  return 0 === n && r !== e && (null == r || r != r) || n > 0;
}

function gn(t, e, r, n) {
  var i = wn(t),
      o = new Or(r).map(function (t) {
    return t.size;
  });
  return i.size = n ? o.max() : o.min(), i.__iterate = function (t, e) {
    for (var r, n = this.__iterator(lr, e), i = 0; !(r = n.next()).done && !1 !== t(r.value, i++, this);) {
      ;
    }

    return i;
  }, i.__iteratorUncached = function (t, i) {
    var o = r.map(function (t) {
      return t = $e(t), br(i ? t.reverse() : t);
    }),
        a = 0,
        s = !1;
    return new vr(function () {
      var r;
      return s || (r = o.map(function (t) {
        return t.next();
      }), s = n ? r.every(function (t) {
        return t.done;
      }) : r.some(function (t) {
        return t.done;
      })), s ? {
        value: void 0,
        done: !0
      } : yr(t, a++, e.apply(null, r.map(function (t) {
        return t.value;
      })));
    });
  }, i;
}

function mn(t, e) {
  return t === e ? t : nr(t) ? e : t.constructor(e);
}

function _n(t) {
  if (t !== Object(t)) throw new TypeError("Expected [K, V] tuple: " + t);
}

function bn(t) {
  return Je(t) ? Qe : Ye(t) ? tr : er;
}

function wn(t) {
  return Object.create((Je(t) ? Ir : Ye(t) ? kr : Lr).prototype);
}

function Sn() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Er.prototype.cacheResult.call(this);
}

function xn(t, e) {
  return void 0 === t && void 0 === e ? 0 : void 0 === t ? 1 : void 0 === e ? -1 : t > e ? 1 : t < e ? -1 : 0;
}

function En(t, e) {
  e = e || 0;

  for (var r = Math.max(0, t.length - e), n = new Array(r), i = 0; i < r; i++) {
    n[i] = t[i + e];
  }

  return n;
}

function In(t, e) {
  if (!t) throw new Error(e);
}

function kn(t) {
  In(t !== 1 / 0, "Cannot perform this action with an infinite size.");
}

function Ln(t) {
  if (xr(t) && "string" != typeof t) return t;
  if (ur(t)) return t.toArray();
  throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + t);
}

function On(t) {
  return t && ("function" != typeof t.constructor || "Object" === t.constructor.name);
}

function Tn(t) {
  return "object" == typeof t && (ar(t) || Array.isArray(t) || On(t));
}

function zn(t) {
  try {
    return "string" == typeof t ? JSON.stringify(t) : String(t);
  } catch (e) {
    return JSON.stringify(t);
  }
}

function jn(t, e, r) {
  return ar(t) ? t.get(e, r) : function (t, e) {
    return ar(t) ? t.has(e) : Tn(t) && Sr.call(t, e);
  }(t, e) ? "function" == typeof t.get ? t.get(e) : t[e] : r;
}

function Pn(t) {
  if (Array.isArray(t)) return En(t);
  var e = {};

  for (var r in t) {
    Sr.call(t, r) && (e[r] = t[r]);
  }

  return e;
}

function Rn(t, e, r, n) {
  n || (n = r, r = void 0);

  var i = function t(e, r, n, i, o, a) {
    var s = r === Ce;

    if (i === n.length) {
      var u = s ? o : r,
          c = a(u);
      return c === u ? r : c;
    }

    if (!s && !Tn(r)) throw new TypeError("Cannot update within non-data-structure value in path [" + n.slice(0, i).map(zn) + "]: " + r);
    var l = n[i];
    var p = s ? Ce : jn(r, l, Ce);
    var h = t(p === Ce ? e : ar(p), p, n, i + 1, o, a);
    return h === p ? r : h === Ce ? function (t, e) {
      if (!Tn(t)) throw new TypeError("Cannot update non-data-structure value: " + t);

      if (ar(t)) {
        if (!t.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + t);
        return t.remove(e);
      }

      if (!Sr.call(t, e)) return t;
      var r = Pn(t);
      return Array.isArray(r) ? r.splice(e, 1) : delete r[e], r;
    }(r, l) : function (t, e, r) {
      if (!Tn(t)) throw new TypeError("Cannot update non-data-structure value: " + t);

      if (ar(t)) {
        if (!t.set) throw new TypeError("Cannot update immutable value without .set() method: " + t);
        return t.set(e, r);
      }

      if (Sr.call(t, e) && r === t[e]) return t;
      var n = Pn(t);
      return n[e] = r, n;
    }(s ? e ? li() : {} : r, l, h);
  }(ar(t), t, Ln(e), 0, r, n);

  return i === Ce ? r : i;
}

function Cn(t, e) {
  return function (t, e, r) {
    return Rn(t, e, Ce, function () {
      return r;
    });
  }(this, t, e);
}

function Mn(t) {
  return function (t, e) {
    return Rn(t, e, function () {
      return Ce;
    });
  }(this, t);
}

function An(t, e, r, n) {
  return Rn(t, [e], r, n);
}

function Dn(t, e, r) {
  return 1 === arguments.length ? t(this) : An(this, t, e, r);
}

function qn(t, e, r) {
  return Rn(this, t, e, r);
}

function Bn() {
  for (var t = [], e = arguments.length; e--;) {
    t[e] = arguments[e];
  }

  return Un(this, t);
}

function Fn(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0;) {
    e[r] = arguments[r + 1];
  }

  if ("function" != typeof t) throw new TypeError("Invalid merger function: " + t);
  return Un(this, e, t);
}

function Un(t, e, r) {
  for (var n = [], i = 0; i < e.length; i++) {
    var o = Qe(e[i]);
    0 !== o.size && n.push(o);
  }

  return 0 === n.length ? t : 0 !== t.toSeq().size || t.__ownerID || 1 !== n.length ? t.withMutations(function (t) {
    for (var e = r ? function (e, n) {
      An(t, n, Ce, function (t) {
        return t === Ce ? e : r(t, e, n);
      });
    } : function (e, r) {
      t.set(r, e);
    }, i = 0; i < n.length; i++) {
      n[i].forEach(e);
    }
  }) : t.constructor(n[0]);
}

function Vn(t, e, r) {
  return Nn(t, e, function (t) {
    return function e(r, n, i) {
      return Tn(r) && Tn(n) ? Nn(r, [n], e) : t ? t(r, n, i) : n;
    };
  }(r));
}

function Nn(t, e, r) {
  if (!Tn(t)) throw new TypeError("Cannot merge into non-data-structure value: " + t);
  if (ar(t)) return "function" == typeof r && t.mergeWith ? t.mergeWith.apply(t, [r].concat(e)) : t.merge ? t.merge.apply(t, e) : t.concat.apply(t, e);

  for (var n = Array.isArray(t), i = t, o = n ? tr : Qe, a = n ? function (e) {
    i === t && (i = Pn(i)), i.push(e);
  } : function (e, n) {
    var o = Sr.call(i, n),
        a = o && r ? r(i[n], e, n) : e;
    o && a === i[n] || (i === t && (i = Pn(i)), i[n] = a);
  }, s = 0; s < e.length; s++) {
    o(e[s]).forEach(a);
  }

  return i;
}

function Hn() {
  for (var t = [], e = arguments.length; e--;) {
    t[e] = arguments[e];
  }

  return Vn(this, t);
}

function Kn(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0;) {
    e[r] = arguments[r + 1];
  }

  return Vn(this, e, t);
}

function Wn(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0;) {
    e[r] = arguments[r + 1];
  }

  return Rn(this, t, li(), function (t) {
    return Nn(t, e);
  });
}

function Gn(t) {
  for (var e = [], r = arguments.length - 1; r-- > 0;) {
    e[r] = arguments[r + 1];
  }

  return Rn(this, t, li(), function (t) {
    return Vn(t, e);
  });
}

function Jn(t) {
  var e = this.asMutable();
  return t(e), e.wasAltered() ? e.__ensureOwner(this.__ownerID) : this;
}

function Zn() {
  return this.__ownerID ? this : this.__ensureOwner(new Ae());
}

function Yn() {
  return this.__ensureOwner();
}

function Xn() {
  return this.__altered;
}

nn.prototype.cacheResult = rn.prototype.cacheResult = on.prototype.cacheResult = an.prototype.cacheResult = Sn;

var $n = function (t) {
  function e(e) {
    return null == e ? li() : Dr(e) && !ur(e) ? e : li().withMutations(function (r) {
      var n = t(e);
      kn(n.size), n.forEach(function (t, e) {
        return r.set(e, t);
      });
    });
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    for (var t = [], e = arguments.length; e--;) {
      t[e] = arguments[e];
    }

    return li().withMutations(function (e) {
      for (var r = 0; r < t.length; r += 2) {
        if (r + 1 >= t.length) throw new Error("Missing value for key: " + t[r]);
        e.set(t[r], t[r + 1]);
      }
    });
  }, e.prototype.toString = function () {
    return this.__toString("Map {", "}");
  }, e.prototype.get = function (t, e) {
    return this._root ? this._root.get(0, void 0, t, e) : e;
  }, e.prototype.set = function (t, e) {
    return pi(this, t, e);
  }, e.prototype.remove = function (t) {
    return pi(this, t, Ce);
  }, e.prototype.deleteAll = function (t) {
    var e = $e(t);
    return 0 === e.size ? this : this.withMutations(function (t) {
      e.forEach(function (e) {
        return t.remove(e);
      });
    });
  }, e.prototype.clear = function () {
    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : li();
  }, e.prototype.sort = function (t) {
    return Ai(dn(this, t));
  }, e.prototype.sortBy = function (t, e) {
    return Ai(dn(this, e, t));
  }, e.prototype.map = function (t, e) {
    return this.withMutations(function (r) {
      r.forEach(function (n, i) {
        r.set(i, t.call(e, n, i, r));
      });
    });
  }, e.prototype.__iterator = function (t, e) {
    return new ai(this, t, e);
  }, e.prototype.__iterate = function (t, e) {
    var r = this,
        n = 0;
    return this._root && this._root.iterate(function (e) {
      return n++, t(e[1], e[0], r);
    }, e), n;
  }, e.prototype.__ensureOwner = function (t) {
    return t === this.__ownerID ? this : t ? ci(this.size, this._root, t, this.__hash) : 0 === this.size ? li() : (this.__ownerID = t, this.__altered = !1, this);
  }, e;
}(Qe);

$n.isMap = Dr;
var Qn = $n.prototype;
Qn[Ar] = !0, Qn.delete = Qn.remove, Qn.removeAll = Qn.deleteAll, Qn.setIn = Cn, Qn.removeIn = Qn.deleteIn = Mn, Qn.update = Dn, Qn.updateIn = qn, Qn.merge = Qn.concat = Bn, Qn.mergeWith = Fn, Qn.mergeDeep = Hn, Qn.mergeDeepWith = Kn, Qn.mergeIn = Wn, Qn.mergeDeepIn = Gn, Qn.withMutations = Jn, Qn.wasAltered = Xn, Qn.asImmutable = Yn, Qn["@@transducer/init"] = Qn.asMutable = Zn, Qn["@@transducer/step"] = function (t, e) {
  return t.set(e[0], e[1]);
}, Qn["@@transducer/result"] = function (t) {
  return t.asImmutable();
};

var ti = function ti(t, e) {
  this.ownerID = t, this.entries = e;
};

ti.prototype.get = function (t, e, r, n) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++) {
    if (Fr(r, i[o][0])) return i[o][1];
  }

  return n;
}, ti.prototype.update = function (t, e, r, n, i, o, a) {
  for (var s = i === Ce, u = this.entries, c = 0, l = u.length; c < l && !Fr(n, u[c][0]); c++) {
    ;
  }

  var p = c < l;
  if (p ? u[c][1] === i : s) return this;

  if (Me(a), (s || !p) && Me(o), !s || 1 !== u.length) {
    if (!p && !s && u.length >= gi) return function (t, e, r, n) {
      t || (t = new Ae());

      for (var i = new ii(t, Hr(r), [r, n]), o = 0; o < e.length; o++) {
        var a = e[o];
        i = i.update(t, 0, void 0, a[0], a[1]);
      }

      return i;
    }(t, u, n, i);
    var h = t && t === this.ownerID,
        f = h ? u : En(u);
    return p ? s ? c === l - 1 ? f.pop() : f[c] = f.pop() : f[c] = [n, i] : f.push([n, i]), h ? (this.entries = f, this) : new ti(t, f);
  }
};

var ei = function ei(t, e, r) {
  this.ownerID = t, this.bitmap = e, this.nodes = r;
};

ei.prototype.get = function (t, e, r, n) {
  void 0 === e && (e = Hr(r));
  var i = 1 << ((0 === t ? e : e >>> t) & Re),
      o = this.bitmap;
  return 0 == (o & i) ? n : this.nodes[vi(o & i - 1)].get(t + je, e, r, n);
}, ei.prototype.update = function (t, e, r, n, i, o, a) {
  void 0 === r && (r = Hr(n));
  var s = (0 === e ? r : r >>> e) & Re,
      u = 1 << s,
      c = this.bitmap,
      l = 0 != (c & u);
  if (!l && i === Ce) return this;
  var p = vi(c & u - 1),
      h = this.nodes,
      f = l ? h[p] : void 0,
      d = hi(f, t, e + je, r, n, i, o, a);
  if (d === f) return this;
  if (!l && d && h.length >= mi) return function (t, e, r, n, i) {
    for (var o = 0, a = new Array(Pe), s = 0; 0 !== r; s++, r >>>= 1) {
      a[s] = 1 & r ? e[o++] : void 0;
    }

    return a[n] = i, new ri(t, o + 1, a);
  }(t, h, c, s, d);
  if (l && !d && 2 === h.length && fi(h[1 ^ p])) return h[1 ^ p];
  if (l && d && 1 === h.length && fi(d)) return d;
  var v = t && t === this.ownerID,
      y = l ? d ? c : c ^ u : c | u,
      g = l ? d ? yi(h, p, d, v) : function (t, e, r) {
    var n = t.length - 1;
    if (r && e === n) return t.pop(), t;

    for (var i = new Array(n), o = 0, a = 0; a < n; a++) {
      a === e && (o = 1), i[a] = t[a + o];
    }

    return i;
  }(h, p, v) : function (t, e, r, n) {
    var i = t.length + 1;
    if (n && e + 1 === i) return t[e] = r, t;

    for (var o = new Array(i), a = 0, s = 0; s < i; s++) {
      s === e ? (o[s] = r, a = -1) : o[s] = t[s + a];
    }

    return o;
  }(h, p, d, v);
  return v ? (this.bitmap = y, this.nodes = g, this) : new ei(t, y, g);
};

var ri = function ri(t, e, r) {
  this.ownerID = t, this.count = e, this.nodes = r;
};

ri.prototype.get = function (t, e, r, n) {
  void 0 === e && (e = Hr(r));
  var i = (0 === t ? e : e >>> t) & Re,
      o = this.nodes[i];
  return o ? o.get(t + je, e, r, n) : n;
}, ri.prototype.update = function (t, e, r, n, i, o, a) {
  void 0 === r && (r = Hr(n));
  var s = (0 === e ? r : r >>> e) & Re,
      u = i === Ce,
      c = this.nodes,
      l = c[s];
  if (u && !l) return this;
  var p = hi(l, t, e + je, r, n, i, o, a);
  if (p === l) return this;
  var h = this.count;

  if (l) {
    if (!p && --h < _i) return function (t, e, r, n) {
      for (var i = 0, o = 0, a = new Array(r), s = 0, u = 1, c = e.length; s < c; s++, u <<= 1) {
        var l = e[s];
        void 0 !== l && s !== n && (i |= u, a[o++] = l);
      }

      return new ei(t, i, a);
    }(t, c, h, s);
  } else h++;

  var f = t && t === this.ownerID,
      d = yi(c, s, p, f);
  return f ? (this.count = h, this.nodes = d, this) : new ri(t, h, d);
};

var ni = function ni(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entries = r;
};

ni.prototype.get = function (t, e, r, n) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++) {
    if (Fr(r, i[o][0])) return i[o][1];
  }

  return n;
}, ni.prototype.update = function (t, e, r, n, i, o, a) {
  void 0 === r && (r = Hr(n));
  var s = i === Ce;
  if (r !== this.keyHash) return s ? this : (Me(a), Me(o), di(this, t, e, r, [n, i]));

  for (var u = this.entries, c = 0, l = u.length; c < l && !Fr(n, u[c][0]); c++) {
    ;
  }

  var p = c < l;
  if (p ? u[c][1] === i : s) return this;
  if (Me(a), (s || !p) && Me(o), s && 2 === l) return new ii(t, this.keyHash, u[1 ^ c]);
  var h = t && t === this.ownerID,
      f = h ? u : En(u);
  return p ? s ? c === l - 1 ? f.pop() : f[c] = f.pop() : f[c] = [n, i] : f.push([n, i]), h ? (this.entries = f, this) : new ni(t, this.keyHash, f);
};

var ii = function ii(t, e, r) {
  this.ownerID = t, this.keyHash = e, this.entry = r;
};

ii.prototype.get = function (t, e, r, n) {
  return Fr(r, this.entry[0]) ? this.entry[1] : n;
}, ii.prototype.update = function (t, e, r, n, i, o, a) {
  var s = i === Ce,
      u = Fr(n, this.entry[0]);
  return (u ? i === this.entry[1] : s) ? this : (Me(a), s ? void Me(o) : u ? t && t === this.ownerID ? (this.entry[1] = i, this) : new ii(t, this.keyHash, [n, i]) : (Me(o), di(this, t, e, Hr(n), [n, i])));
}, ti.prototype.iterate = ni.prototype.iterate = function (t, e) {
  for (var r = this.entries, n = 0, i = r.length - 1; n <= i; n++) {
    if (!1 === t(r[e ? i - n : n])) return !1;
  }
}, ei.prototype.iterate = ri.prototype.iterate = function (t, e) {
  for (var r = this.nodes, n = 0, i = r.length - 1; n <= i; n++) {
    var o = r[e ? i - n : n];
    if (o && !1 === o.iterate(t, e)) return !1;
  }
}, ii.prototype.iterate = function (t, e) {
  return t(this.entry);
};

var oi,
    ai = function (t) {
  function e(t, e, r) {
    this._type = e, this._reverse = r, this._stack = t._root && ui(t._root);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.next = function () {
    for (var t = this._type, e = this._stack; e;) {
      var r = e.node,
          n = e.index++,
          i = void 0;

      if (r.entry) {
        if (0 === n) return si(t, r.entry);
      } else if (r.entries) {
        if (n <= (i = r.entries.length - 1)) return si(t, r.entries[this._reverse ? i - n : n]);
      } else if (n <= (i = r.nodes.length - 1)) {
        var o = r.nodes[this._reverse ? i - n : n];

        if (o) {
          if (o.entry) return si(t, o.entry);
          e = this._stack = ui(o, e);
        }

        continue;
      }

      e = this._stack = this._stack.__prev;
    }

    return {
      value: void 0,
      done: !0
    };
  }, e;
}(vr);

function si(t, e) {
  return yr(t, e[0], e[1]);
}

function ui(t, e) {
  return {
    node: t,
    index: 0,
    __prev: e
  };
}

function ci(t, e, r, n) {
  var i = Object.create(Qn);
  return i.size = t, i._root = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}

function li() {
  return oi || (oi = ci(0));
}

function pi(t, e, r) {
  var n, i;

  if (t._root) {
    var o = {
      value: !1
    },
        a = {
      value: !1
    };
    if (n = hi(t._root, t.__ownerID, 0, void 0, e, r, o, a), !a.value) return t;
    i = t.size + (o.value ? r === Ce ? -1 : 1 : 0);
  } else {
    if (r === Ce) return t;
    i = 1, n = new ti(t.__ownerID, [[e, r]]);
  }

  return t.__ownerID ? (t.size = i, t._root = n, t.__hash = void 0, t.__altered = !0, t) : n ? ci(i, n) : li();
}

function hi(t, e, r, n, i, o, a, s) {
  return t ? t.update(e, r, n, i, o, a, s) : o === Ce ? t : (Me(s), Me(a), new ii(e, n, [i, o]));
}

function fi(t) {
  return t.constructor === ii || t.constructor === ni;
}

function di(t, e, r, n, i) {
  if (t.keyHash === n) return new ni(e, n, [t.entry, i]);
  var o,
      a = (0 === r ? t.keyHash : t.keyHash >>> r) & Re,
      s = (0 === r ? n : n >>> r) & Re,
      u = a === s ? [di(t, e, r + je, n, i)] : (o = new ii(e, n, i), a < s ? [t, o] : [o, t]);
  return new ei(e, 1 << a | 1 << s, u);
}

function vi(t) {
  return t = (t = (858993459 & (t -= t >> 1 & 1431655765)) + (t >> 2 & 858993459)) + (t >> 4) & 252645135, t += t >> 8, 127 & (t += t >> 16);
}

function yi(t, e, r, n) {
  var i = n ? t : En(t);
  return i[e] = r, i;
}

var gi = Pe / 4,
    mi = Pe / 2,
    _i = Pe / 4,
    bi = "@@__IMMUTABLE_LIST__@@";

function wi(t) {
  return Boolean(t && t[bi]);
}

var Si = function (t) {
  function e(e) {
    var r = Ti();
    if (null == e) return r;
    if (wi(e)) return e;
    var n = t(e),
        i = n.size;
    return 0 === i ? r : (kn(i), i > 0 && i < Pe ? Oi(0, i, je, null, new Ei(n.toArray())) : r.withMutations(function (t) {
      t.setSize(i), n.forEach(function (e, r) {
        return t.set(r, e);
      });
    }));
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return this(arguments);
  }, e.prototype.toString = function () {
    return this.__toString("List [", "]");
  }, e.prototype.get = function (t, e) {
    if ((t = qe(this, t)) >= 0 && t < this.size) {
      var r = Pi(this, t += this._origin);
      return r && r.array[t & Re];
    }

    return e;
  }, e.prototype.set = function (t, e) {
    return function (t, e, r) {
      if ((e = qe(t, e)) != e) return t;
      if (e >= t.size || e < 0) return t.withMutations(function (t) {
        e < 0 ? Ri(t, e).set(0, r) : Ri(t, 0, e + 1).set(e, r);
      });
      e += t._origin;
      var n = t._tail,
          i = t._root,
          o = {
        value: !1
      };
      e >= Ci(t._capacity) ? n = zi(n, t.__ownerID, 0, e, r, o) : i = zi(i, t.__ownerID, t._level, e, r, o);
      if (!o.value) return t;
      if (t.__ownerID) return t._root = i, t._tail = n, t.__hash = void 0, t.__altered = !0, t;
      return Oi(t._origin, t._capacity, t._level, i, n);
    }(this, t, e);
  }, e.prototype.remove = function (t) {
    return this.has(t) ? 0 === t ? this.shift() : t === this.size - 1 ? this.pop() : this.splice(t, 1) : this;
  }, e.prototype.insert = function (t, e) {
    return this.splice(t, 0, e);
  }, e.prototype.clear = function () {
    return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = je, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : Ti();
  }, e.prototype.push = function () {
    var t = arguments,
        e = this.size;
    return this.withMutations(function (r) {
      Ri(r, 0, e + t.length);

      for (var n = 0; n < t.length; n++) {
        r.set(e + n, t[n]);
      }
    });
  }, e.prototype.pop = function () {
    return Ri(this, 0, -1);
  }, e.prototype.unshift = function () {
    var t = arguments;
    return this.withMutations(function (e) {
      Ri(e, -t.length);

      for (var r = 0; r < t.length; r++) {
        e.set(r, t[r]);
      }
    });
  }, e.prototype.shift = function () {
    return Ri(this, 1);
  }, e.prototype.concat = function () {
    for (var e = arguments, r = [], n = 0; n < arguments.length; n++) {
      var i = e[n],
          o = t("string" != typeof i && mr(i) ? i : [i]);
      0 !== o.size && r.push(o);
    }

    return 0 === r.length ? this : 0 !== this.size || this.__ownerID || 1 !== r.length ? this.withMutations(function (t) {
      r.forEach(function (e) {
        return e.forEach(function (e) {
          return t.push(e);
        });
      });
    }) : this.constructor(r[0]);
  }, e.prototype.setSize = function (t) {
    return Ri(this, 0, t);
  }, e.prototype.map = function (t, e) {
    var r = this;
    return this.withMutations(function (n) {
      for (var i = 0; i < r.size; i++) {
        n.set(i, t.call(e, n.get(i), i, n));
      }
    });
  }, e.prototype.slice = function (t, e) {
    var r = this.size;
    return Fe(t, e, r) ? this : Ri(this, Ue(t, r), Ve(e, r));
  }, e.prototype.__iterator = function (t, e) {
    var r = e ? this.size : 0,
        n = Li(this, e);
    return new vr(function () {
      var i = n();
      return i === ki ? {
        value: void 0,
        done: !0
      } : yr(t, e ? --r : r++, i);
    });
  }, e.prototype.__iterate = function (t, e) {
    for (var r, n = e ? this.size : 0, i = Li(this, e); (r = i()) !== ki && !1 !== t(r, e ? --n : n++, this);) {
      ;
    }

    return n;
  }, e.prototype.__ensureOwner = function (t) {
    return t === this.__ownerID ? this : t ? Oi(this._origin, this._capacity, this._level, this._root, this._tail, t, this.__hash) : 0 === this.size ? Ti() : (this.__ownerID = t, this.__altered = !1, this);
  }, e;
}(tr);

Si.isList = wi;
var xi = Si.prototype;
xi[bi] = !0, xi.delete = xi.remove, xi.merge = xi.concat, xi.setIn = Cn, xi.deleteIn = xi.removeIn = Mn, xi.update = Dn, xi.updateIn = qn, xi.mergeIn = Wn, xi.mergeDeepIn = Gn, xi.withMutations = Jn, xi.wasAltered = Xn, xi.asImmutable = Yn, xi["@@transducer/init"] = xi.asMutable = Zn, xi["@@transducer/step"] = function (t, e) {
  return t.push(e);
}, xi["@@transducer/result"] = function (t) {
  return t.asImmutable();
};

var Ei = function Ei(t, e) {
  this.array = t, this.ownerID = e;
};

Ei.prototype.removeBefore = function (t, e, r) {
  if (r === e ? 1 << e : 0 === this.array.length) return this;
  var n = r >>> e & Re;
  if (n >= this.array.length) return new Ei([], t);
  var i,
      o = 0 === n;

  if (e > 0) {
    var a = this.array[n];
    if ((i = a && a.removeBefore(t, e - je, r)) === a && o) return this;
  }

  if (o && !i) return this;
  var s = ji(this, t);
  if (!o) for (var u = 0; u < n; u++) {
    s.array[u] = void 0;
  }
  return i && (s.array[n] = i), s;
}, Ei.prototype.removeAfter = function (t, e, r) {
  if (r === (e ? 1 << e : 0) || 0 === this.array.length) return this;
  var n,
      i = r - 1 >>> e & Re;
  if (i >= this.array.length) return this;

  if (e > 0) {
    var o = this.array[i];
    if ((n = o && o.removeAfter(t, e - je, r)) === o && i === this.array.length - 1) return this;
  }

  var a = ji(this, t);
  return a.array.splice(i + 1), n && (a.array[i] = n), a;
};
var Ii,
    ki = {};

function Li(t, e) {
  var r = t._origin,
      n = t._capacity,
      i = Ci(n),
      o = t._tail;
  return a(t._root, t._level, 0);

  function a(t, s, u) {
    return 0 === s ? function (t, a) {
      var s = a === i ? o && o.array : t && t.array,
          u = a > r ? 0 : r - a,
          c = n - a;
      c > Pe && (c = Pe);
      return function () {
        if (u === c) return ki;
        var t = e ? --c : u++;
        return s && s[t];
      };
    }(t, u) : function (t, i, o) {
      var s,
          u = t && t.array,
          c = o > r ? 0 : r - o >> i,
          l = 1 + (n - o >> i);
      l > Pe && (l = Pe);
      return function () {
        for (;;) {
          if (s) {
            var t = s();
            if (t !== ki) return t;
            s = null;
          }

          if (c === l) return ki;
          var r = e ? --l : c++;
          s = a(u && u[r], i - je, o + (r << i));
        }
      };
    }(t, s, u);
  }
}

function Oi(t, e, r, n, i, o, a) {
  var s = Object.create(xi);
  return s.size = e - t, s._origin = t, s._capacity = e, s._level = r, s._root = n, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
}

function Ti() {
  return Ii || (Ii = Oi(0, 0, je));
}

function zi(t, e, r, n, i, o) {
  var a,
      s = n >>> r & Re,
      u = t && s < t.array.length;
  if (!u && void 0 === i) return t;

  if (r > 0) {
    var c = t && t.array[s],
        l = zi(c, e, r - je, n, i, o);
    return l === c ? t : ((a = ji(t, e)).array[s] = l, a);
  }

  return u && t.array[s] === i ? t : (o && Me(o), a = ji(t, e), void 0 === i && s === a.array.length - 1 ? a.array.pop() : a.array[s] = i, a);
}

function ji(t, e) {
  return e && t && e === t.ownerID ? t : new Ei(t ? t.array.slice() : [], e);
}

function Pi(t, e) {
  if (e >= Ci(t._capacity)) return t._tail;

  if (e < 1 << t._level + je) {
    for (var r = t._root, n = t._level; r && n > 0;) {
      r = r.array[e >>> n & Re], n -= je;
    }

    return r;
  }
}

function Ri(t, e, r) {
  void 0 !== e && (e |= 0), void 0 !== r && (r |= 0);
  var n = t.__ownerID || new Ae(),
      i = t._origin,
      o = t._capacity,
      a = i + e,
      s = void 0 === r ? o : r < 0 ? o + r : i + r;
  if (a === i && s === o) return t;
  if (a >= s) return t.clear();

  for (var u = t._level, c = t._root, l = 0; a + l < 0;) {
    c = new Ei(c && c.array.length ? [void 0, c] : [], n), l += 1 << (u += je);
  }

  l && (a += l, i += l, s += l, o += l);

  for (var p = Ci(o), h = Ci(s); h >= 1 << u + je;) {
    c = new Ei(c && c.array.length ? [c] : [], n), u += je;
  }

  var f = t._tail,
      d = h < p ? Pi(t, s - 1) : h > p ? new Ei([], n) : f;

  if (f && h > p && a < o && f.array.length) {
    for (var v = c = ji(c, n), y = u; y > je; y -= je) {
      var g = p >>> y & Re;
      v = v.array[g] = ji(v.array[g], n);
    }

    v.array[p >>> je & Re] = f;
  }

  if (s < o && (d = d && d.removeAfter(n, 0, s)), a >= h) a -= h, s -= h, u = je, c = null, d = d && d.removeBefore(n, 0, a);else if (a > i || h < p) {
    for (l = 0; c;) {
      var m = a >>> u & Re;
      if (m !== h >>> u & Re) break;
      m && (l += (1 << u) * m), u -= je, c = c.array[m];
    }

    c && a > i && (c = c.removeBefore(n, u, a - l)), c && h < p && (c = c.removeAfter(n, u, h - l)), l && (a -= l, s -= l);
  }
  return t.__ownerID ? (t.size = s - a, t._origin = a, t._capacity = s, t._level = u, t._root = c, t._tail = d, t.__hash = void 0, t.__altered = !0, t) : Oi(a, s, u, c, d);
}

function Ci(t) {
  return t < Pe ? 0 : t - 1 >>> je << je;
}

var Mi,
    Ai = function (t) {
  function e(t) {
    return null == t ? qi() : qr(t) ? t : qi().withMutations(function (e) {
      var r = Qe(t);
      kn(r.size), r.forEach(function (t, r) {
        return e.set(r, t);
      });
    });
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return this(arguments);
  }, e.prototype.toString = function () {
    return this.__toString("OrderedMap {", "}");
  }, e.prototype.get = function (t, e) {
    var r = this._map.get(t);

    return void 0 !== r ? this._list.get(r)[1] : e;
  }, e.prototype.clear = function () {
    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : qi();
  }, e.prototype.set = function (t, e) {
    return Bi(this, t, e);
  }, e.prototype.remove = function (t) {
    return Bi(this, t, Ce);
  }, e.prototype.wasAltered = function () {
    return this._map.wasAltered() || this._list.wasAltered();
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    return this._list.__iterate(function (e) {
      return e && t(e[1], e[0], r);
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    return this._list.fromEntrySeq().__iterator(t, e);
  }, e.prototype.__ensureOwner = function (t) {
    if (t === this.__ownerID) return this;

    var e = this._map.__ensureOwner(t),
        r = this._list.__ensureOwner(t);

    return t ? Di(e, r, t, this.__hash) : 0 === this.size ? qi() : (this.__ownerID = t, this._map = e, this._list = r, this);
  }, e;
}($n);

function Di(t, e, r, n) {
  var i = Object.create(Ai.prototype);
  return i.size = t ? t.size : 0, i._map = t, i._list = e, i.__ownerID = r, i.__hash = n, i;
}

function qi() {
  return Mi || (Mi = Di(li(), Ti()));
}

function Bi(t, e, r) {
  var n,
      i,
      o = t._map,
      a = t._list,
      s = o.get(e),
      u = void 0 !== s;

  if (r === Ce) {
    if (!u) return t;
    a.size >= Pe && a.size >= 2 * o.size ? (n = (i = a.filter(function (t, e) {
      return void 0 !== t && s !== e;
    })).toKeyedSeq().map(function (t) {
      return t[0];
    }).flip().toMap(), t.__ownerID && (n.__ownerID = i.__ownerID = t.__ownerID)) : (n = o.remove(e), i = s === a.size - 1 ? a.pop() : a.set(s, void 0));
  } else if (u) {
    if (r === a.get(s)[1]) return t;
    n = o, i = a.set(s, [e, r]);
  } else n = o.set(e, a.size), i = a.set(a.size, [e, r]);

  return t.__ownerID ? (t.size = n.size, t._map = n, t._list = i, t.__hash = void 0, t) : Di(n, i);
}

Ai.isOrderedMap = qr, Ai.prototype[sr] = !0, Ai.prototype.delete = Ai.prototype.remove;
var Fi = "@@__IMMUTABLE_STACK__@@";

function Ui(t) {
  return Boolean(t && t[Fi]);
}

var Vi = function (t) {
  function e(t) {
    return null == t ? Wi() : Ui(t) ? t : Wi().pushAll(t);
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return this(arguments);
  }, e.prototype.toString = function () {
    return this.__toString("Stack [", "]");
  }, e.prototype.get = function (t, e) {
    var r = this._head;

    for (t = qe(this, t); r && t--;) {
      r = r.next;
    }

    return r ? r.value : e;
  }, e.prototype.peek = function () {
    return this._head && this._head.value;
  }, e.prototype.push = function () {
    var t = arguments;
    if (0 === arguments.length) return this;

    for (var e = this.size + arguments.length, r = this._head, n = arguments.length - 1; n >= 0; n--) {
      r = {
        value: t[n],
        next: r
      };
    }

    return this.__ownerID ? (this.size = e, this._head = r, this.__hash = void 0, this.__altered = !0, this) : Ki(e, r);
  }, e.prototype.pushAll = function (e) {
    if (0 === (e = t(e)).size) return this;
    if (0 === this.size && Ui(e)) return e;
    kn(e.size);
    var r = this.size,
        n = this._head;
    return e.__iterate(function (t) {
      r++, n = {
        value: t,
        next: n
      };
    }, !0), this.__ownerID ? (this.size = r, this._head = n, this.__hash = void 0, this.__altered = !0, this) : Ki(r, n);
  }, e.prototype.pop = function () {
    return this.slice(1);
  }, e.prototype.clear = function () {
    return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : Wi();
  }, e.prototype.slice = function (e, r) {
    if (Fe(e, r, this.size)) return this;
    var n = Ue(e, this.size);
    if (Ve(r, this.size) !== this.size) return t.prototype.slice.call(this, e, r);

    for (var i = this.size - n, o = this._head; n--;) {
      o = o.next;
    }

    return this.__ownerID ? (this.size = i, this._head = o, this.__hash = void 0, this.__altered = !0, this) : Ki(i, o);
  }, e.prototype.__ensureOwner = function (t) {
    return t === this.__ownerID ? this : t ? Ki(this.size, this._head, t, this.__hash) : 0 === this.size ? Wi() : (this.__ownerID = t, this.__altered = !1, this);
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    if (e) return new Or(this.toArray()).__iterate(function (e, n) {
      return t(e, n, r);
    }, e);

    for (var n = 0, i = this._head; i && !1 !== t(i.value, n++, this);) {
      i = i.next;
    }

    return n;
  }, e.prototype.__iterator = function (t, e) {
    if (e) return new Or(this.toArray()).__iterator(t, e);
    var r = 0,
        n = this._head;
    return new vr(function () {
      if (n) {
        var e = n.value;
        return n = n.next, yr(t, r++, e);
      }

      return {
        value: void 0,
        done: !0
      };
    });
  }, e;
}(tr);

Vi.isStack = Ui;
var Ni,
    Hi = Vi.prototype;

function Ki(t, e, r, n) {
  var i = Object.create(Hi);
  return i.size = t, i._head = e, i.__ownerID = r, i.__hash = n, i.__altered = !1, i;
}

function Wi() {
  return Ni || (Ni = Ki(0));
}

Hi[Fi] = !0, Hi.shift = Hi.pop, Hi.unshift = Hi.push, Hi.unshiftAll = Hi.pushAll, Hi.withMutations = Jn, Hi.wasAltered = Xn, Hi.asImmutable = Yn, Hi["@@transducer/init"] = Hi.asMutable = Zn, Hi["@@transducer/step"] = function (t, e) {
  return t.unshift(e);
}, Hi["@@transducer/result"] = function (t) {
  return t.asImmutable();
};
var Gi = "@@__IMMUTABLE_SET__@@";

function Ji(t) {
  return Boolean(t && t[Gi]);
}

function Zi(t) {
  return Ji(t) && ur(t);
}

function Yi(t, e) {
  if (t === e) return !0;
  if (!We(e) || void 0 !== t.size && void 0 !== e.size && t.size !== e.size || void 0 !== t.__hash && void 0 !== e.__hash && t.__hash !== e.__hash || Je(t) !== Je(e) || Ye(t) !== Ye(e) || ur(t) !== ur(e)) return !1;
  if (0 === t.size && 0 === e.size) return !0;
  var r = !Xe(t);

  if (ur(t)) {
    var n = t.entries();
    return e.every(function (t, e) {
      var i = n.next().value;
      return i && Fr(i[1], t) && (r || Fr(i[0], e));
    }) && n.next().done;
  }

  var i = !1;
  if (void 0 === t.size) if (void 0 === e.size) "function" == typeof t.cacheResult && t.cacheResult();else {
    i = !0;
    var o = t;
    t = e, e = o;
  }

  var a = !0,
      s = e.__iterate(function (e, n) {
    if (r ? !t.has(e) : i ? !Fr(e, t.get(n, Ce)) : !Fr(t.get(n, Ce), e)) return a = !1, !1;
  });

  return a && t.size === s;
}

function Xi(t, e) {
  var r = function r(_r2) {
    t.prototype[_r2] = e[_r2];
  };

  return Object.keys(e).forEach(r), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(e).forEach(r), t;
}

function $i(t) {
  if (!t || "object" != typeof t) return t;

  if (!We(t)) {
    if (!Tn(t)) return t;
    t = Er(t);
  }

  if (Je(t)) {
    var e = {};
    return t.__iterate(function (t, r) {
      e[r] = $i(t);
    }), e;
  }

  var r = [];
  return t.__iterate(function (t) {
    r.push($i(t));
  }), r;
}

var Qi = function (t) {
  function e(e) {
    return null == e ? io() : Ji(e) && !ur(e) ? e : io().withMutations(function (r) {
      var n = t(e);
      kn(n.size), n.forEach(function (t) {
        return r.add(t);
      });
    });
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return this(arguments);
  }, e.fromKeys = function (t) {
    return this(Qe(t).keySeq());
  }, e.intersect = function (t) {
    return (t = $e(t).toArray()).length ? eo.intersect.apply(e(t.pop()), t) : io();
  }, e.union = function (t) {
    return (t = $e(t).toArray()).length ? eo.union.apply(e(t.pop()), t) : io();
  }, e.prototype.toString = function () {
    return this.__toString("Set {", "}");
  }, e.prototype.has = function (t) {
    return this._map.has(t);
  }, e.prototype.add = function (t) {
    return ro(this, this._map.set(t, t));
  }, e.prototype.remove = function (t) {
    return ro(this, this._map.remove(t));
  }, e.prototype.clear = function () {
    return ro(this, this._map.clear());
  }, e.prototype.map = function (t, e) {
    var r = this,
        n = [],
        i = [];
    return this.forEach(function (o) {
      var a = t.call(e, o, o, r);
      a !== o && (n.push(o), i.push(a));
    }), this.withMutations(function (t) {
      n.forEach(function (e) {
        return t.remove(e);
      }), i.forEach(function (e) {
        return t.add(e);
      });
    });
  }, e.prototype.union = function () {
    for (var e = [], r = arguments.length; r--;) {
      e[r] = arguments[r];
    }

    return 0 === (e = e.filter(function (t) {
      return 0 !== t.size;
    })).length ? this : 0 !== this.size || this.__ownerID || 1 !== e.length ? this.withMutations(function (r) {
      for (var n = 0; n < e.length; n++) {
        t(e[n]).forEach(function (t) {
          return r.add(t);
        });
      }
    }) : this.constructor(e[0]);
  }, e.prototype.intersect = function () {
    for (var e = [], r = arguments.length; r--;) {
      e[r] = arguments[r];
    }

    if (0 === e.length) return this;
    e = e.map(function (e) {
      return t(e);
    });
    var n = [];
    return this.forEach(function (t) {
      e.every(function (e) {
        return e.includes(t);
      }) || n.push(t);
    }), this.withMutations(function (t) {
      n.forEach(function (e) {
        t.remove(e);
      });
    });
  }, e.prototype.subtract = function () {
    for (var e = [], r = arguments.length; r--;) {
      e[r] = arguments[r];
    }

    if (0 === e.length) return this;
    e = e.map(function (e) {
      return t(e);
    });
    var n = [];
    return this.forEach(function (t) {
      e.some(function (e) {
        return e.includes(t);
      }) && n.push(t);
    }), this.withMutations(function (t) {
      n.forEach(function (e) {
        t.remove(e);
      });
    });
  }, e.prototype.sort = function (t) {
    return So(dn(this, t));
  }, e.prototype.sortBy = function (t, e) {
    return So(dn(this, e, t));
  }, e.prototype.wasAltered = function () {
    return this._map.wasAltered();
  }, e.prototype.__iterate = function (t, e) {
    var r = this;
    return this._map.__iterate(function (e) {
      return t(e, e, r);
    }, e);
  }, e.prototype.__iterator = function (t, e) {
    return this._map.__iterator(t, e);
  }, e.prototype.__ensureOwner = function (t) {
    if (t === this.__ownerID) return this;

    var e = this._map.__ensureOwner(t);

    return t ? this.__make(e, t) : 0 === this.size ? this.__empty() : (this.__ownerID = t, this._map = e, this);
  }, e;
}(er);

Qi.isSet = Ji;
var to,
    eo = Qi.prototype;

function ro(t, e) {
  return t.__ownerID ? (t.size = e.size, t._map = e, t) : e === t._map ? t : 0 === e.size ? t.__empty() : t.__make(e);
}

function no(t, e) {
  var r = Object.create(eo);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}

function io() {
  return to || (to = no(li()));
}

eo[Gi] = !0, eo.delete = eo.remove, eo.merge = eo.concat = eo.union, eo.withMutations = Jn, eo.asImmutable = Yn, eo["@@transducer/init"] = eo.asMutable = Zn, eo["@@transducer/step"] = function (t, e) {
  return t.add(e);
}, eo["@@transducer/result"] = function (t) {
  return t.asImmutable();
}, eo.__empty = io, eo.__make = no;

var oo,
    ao = function (t) {
  function e(t, r, n) {
    if (!(this instanceof e)) return new e(t, r, n);

    if (In(0 !== n, "Cannot step a Range by 0"), t = t || 0, void 0 === r && (r = 1 / 0), n = void 0 === n ? 1 : Math.abs(n), r < t && (n = -n), this._start = t, this._end = r, this._step = n, this.size = Math.max(0, Math.ceil((r - t) / n - 1) + 1), 0 === this.size) {
      if (oo) return oo;
      oo = this;
    }
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.toString = function () {
    return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
  }, e.prototype.get = function (t, e) {
    return this.has(t) ? this._start + qe(this, t) * this._step : e;
  }, e.prototype.includes = function (t) {
    var e = (t - this._start) / this._step;
    return e >= 0 && e < this.size && e === Math.floor(e);
  }, e.prototype.slice = function (t, r) {
    return Fe(t, r, this.size) ? this : (t = Ue(t, this.size), (r = Ve(r, this.size)) <= t ? new e(0, 0) : new e(this.get(t, this._end), this.get(r, this._end), this._step));
  }, e.prototype.indexOf = function (t) {
    var e = t - this._start;

    if (e % this._step == 0) {
      var r = e / this._step;
      if (r >= 0 && r < this.size) return r;
    }

    return -1;
  }, e.prototype.lastIndexOf = function (t) {
    return this.indexOf(t);
  }, e.prototype.__iterate = function (t, e) {
    for (var r = this.size, n = this._step, i = e ? this._start + (r - 1) * n : this._start, o = 0; o !== r && !1 !== t(i, e ? r - ++o : o++, this);) {
      i += e ? -n : n;
    }

    return o;
  }, e.prototype.__iterator = function (t, e) {
    var r = this.size,
        n = this._step,
        i = e ? this._start + (r - 1) * n : this._start,
        o = 0;
    return new vr(function () {
      if (o === r) return {
        value: void 0,
        done: !0
      };
      var a = i;
      return i += e ? -n : n, yr(t, e ? r - ++o : o++, a);
    });
  }, e.prototype.equals = function (t) {
    return t instanceof e ? this._start === t._start && this._end === t._end && this._step === t._step : Yi(this, t);
  }, e;
}(kr);

function so(t, e, r) {
  for (var n = Ln(e), i = 0; i !== n.length;) {
    if ((t = jn(t, n[i++], Ce)) === Ce) return r;
  }

  return t;
}

function uo(t, e) {
  return so(this, t, e);
}

function co() {
  kn(this.size);
  var t = {};
  return this.__iterate(function (e, r) {
    t[r] = e;
  }), t;
}

$e.isIterable = We, $e.isKeyed = Je, $e.isIndexed = Ye, $e.isAssociative = Xe, $e.isOrdered = ur, $e.Iterator = vr, Xi($e, {
  toArray: function toArray() {
    kn(this.size);
    var t = new Array(this.size || 0),
        e = Je(this),
        r = 0;
    return this.__iterate(function (n, i) {
      t[r++] = e ? [i, n] : n;
    }), t;
  },
  toIndexedSeq: function toIndexedSeq() {
    return new nn(this);
  },
  toJS: function toJS() {
    return $i(this);
  },
  toKeyedSeq: function toKeyedSeq() {
    return new rn(this, !0);
  },
  toMap: function toMap() {
    return $n(this.toKeyedSeq());
  },
  toObject: co,
  toOrderedMap: function toOrderedMap() {
    return Ai(this.toKeyedSeq());
  },
  toOrderedSet: function toOrderedSet() {
    return So(Je(this) ? this.valueSeq() : this);
  },
  toSet: function toSet() {
    return Qi(Je(this) ? this.valueSeq() : this);
  },
  toSetSeq: function toSetSeq() {
    return new on(this);
  },
  toSeq: function toSeq() {
    return Ye(this) ? this.toIndexedSeq() : Je(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function toStack() {
    return Vi(Je(this) ? this.valueSeq() : this);
  },
  toList: function toList() {
    return Si(Je(this) ? this.valueSeq() : this);
  },
  toString: function toString() {
    return "[Collection]";
  },
  __toString: function __toString(t, e) {
    return 0 === this.size ? t + e : t + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + e;
  },
  concat: function concat() {
    for (var t = [], e = arguments.length; e--;) {
      t[e] = arguments[e];
    }

    return mn(this, function (t, e) {
      var r = Je(t),
          n = [t].concat(e).map(function (t) {
        return We(t) ? r && (t = Qe(t)) : t = r ? Rr(t) : Cr(Array.isArray(t) ? t : [t]), t;
      }).filter(function (t) {
        return 0 !== t.size;
      });
      if (0 === n.length) return t;

      if (1 === n.length) {
        var i = n[0];
        if (i === t || r && Je(i) || Ye(t) && Ye(i)) return i;
      }

      var o = new Or(n);
      return r ? o = o.toKeyedSeq() : Ye(t) || (o = o.toSetSeq()), (o = o.flatten(!0)).size = n.reduce(function (t, e) {
        if (void 0 !== t) {
          var r = e.size;
          if (void 0 !== r) return t + r;
        }
      }, 0), o;
    }(this, t));
  },
  includes: function includes(t) {
    return this.some(function (e) {
      return Fr(e, t);
    });
  },
  entries: function entries() {
    return this.__iterator(pr);
  },
  every: function every(t, e) {
    kn(this.size);
    var r = !0;
    return this.__iterate(function (n, i, o) {
      if (!t.call(e, n, i, o)) return r = !1, !1;
    }), r;
  },
  filter: function filter(t, e) {
    return mn(this, ln(this, t, e, !0));
  },
  find: function find(t, e, r) {
    var n = this.findEntry(t, e);
    return n ? n[1] : r;
  },
  forEach: function forEach(t, e) {
    return kn(this.size), this.__iterate(e ? t.bind(e) : t);
  },
  join: function join(t) {
    kn(this.size), t = void 0 !== t ? "" + t : ",";
    var e = "",
        r = !0;
    return this.__iterate(function (n) {
      r ? r = !1 : e += t, e += null != n ? n.toString() : "";
    }), e;
  },
  keys: function keys() {
    return this.__iterator(cr);
  },
  map: function map(t, e) {
    return mn(this, un(this, t, e));
  },
  reduce: function reduce(t, e, r) {
    return fo(this, t, e, r, arguments.length < 2, !1);
  },
  reduceRight: function reduceRight(t, e, r) {
    return fo(this, t, e, r, arguments.length < 2, !0);
  },
  reverse: function reverse() {
    return mn(this, cn(this, !0));
  },
  slice: function slice(t, e) {
    return mn(this, pn(this, t, e, !0));
  },
  some: function some(t, e) {
    return !this.every(go(t), e);
  },
  sort: function sort(t) {
    return mn(this, dn(this, t));
  },
  values: function values() {
    return this.__iterator(lr);
  },
  butLast: function butLast() {
    return this.slice(0, -1);
  },
  isEmpty: function isEmpty() {
    return void 0 !== this.size ? 0 === this.size : !this.some(function () {
      return !0;
    });
  },
  count: function count(t, e) {
    return De(t ? this.toSeq().filter(t, e) : this);
  },
  countBy: function countBy(t, e) {
    return function (t, e, r) {
      var n = $n().asMutable();
      return t.__iterate(function (i, o) {
        n.update(e.call(r, i, o, t), 0, function (t) {
          return t + 1;
        });
      }), n.asImmutable();
    }(this, t, e);
  },
  equals: function equals(t) {
    return Yi(this, t);
  },
  entrySeq: function entrySeq() {
    var t = this;
    if (t._cache) return new Or(t._cache);
    var e = t.toSeq().map(yo).toIndexedSeq();
    return e.fromEntrySeq = function () {
      return t.toSeq();
    }, e;
  },
  filterNot: function filterNot(t, e) {
    return this.filter(go(t), e);
  },
  findEntry: function findEntry(t, e, r) {
    var n = r;
    return this.__iterate(function (r, i, o) {
      if (t.call(e, r, i, o)) return n = [i, r], !1;
    }), n;
  },
  findKey: function findKey(t, e) {
    var r = this.findEntry(t, e);
    return r && r[0];
  },
  findLast: function findLast(t, e, r) {
    return this.toKeyedSeq().reverse().find(t, e, r);
  },
  findLastEntry: function findLastEntry(t, e, r) {
    return this.toKeyedSeq().reverse().findEntry(t, e, r);
  },
  findLastKey: function findLastKey(t, e) {
    return this.toKeyedSeq().reverse().findKey(t, e);
  },
  first: function first(t) {
    return this.find(Be, null, t);
  },
  flatMap: function flatMap(t, e) {
    return mn(this, function (t, e, r) {
      var n = bn(t);
      return t.toSeq().map(function (i, o) {
        return n(e.call(r, i, o, t));
      }).flatten(!0);
    }(this, t, e));
  },
  flatten: function flatten(t) {
    return mn(this, fn(this, t, !0));
  },
  fromEntrySeq: function fromEntrySeq() {
    return new an(this);
  },
  get: function get(t, e) {
    return this.find(function (e, r) {
      return Fr(r, t);
    }, void 0, e);
  },
  getIn: uo,
  groupBy: function groupBy(t, e) {
    return function (t, e, r) {
      var n = Je(t),
          i = (ur(t) ? Ai() : $n()).asMutable();

      t.__iterate(function (o, a) {
        i.update(e.call(r, o, a, t), function (t) {
          return (t = t || []).push(n ? [a, o] : o), t;
        });
      });

      var o = bn(t);
      return i.map(function (e) {
        return mn(t, o(e));
      }).asImmutable();
    }(this, t, e);
  },
  has: function has(t) {
    return this.get(t, Ce) !== Ce;
  },
  hasIn: function hasIn(t) {
    return so(this, t, Ce) !== Ce;
  },
  isSubset: function isSubset(t) {
    return t = "function" == typeof t.includes ? t : $e(t), this.every(function (e) {
      return t.includes(e);
    });
  },
  isSuperset: function isSuperset(t) {
    return (t = "function" == typeof t.isSubset ? t : $e(t)).isSubset(this);
  },
  keyOf: function keyOf(t) {
    return this.findKey(function (e) {
      return Fr(e, t);
    });
  },
  keySeq: function keySeq() {
    return this.toSeq().map(vo).toIndexedSeq();
  },
  last: function last(t) {
    return this.toSeq().reverse().first(t);
  },
  lastKeyOf: function lastKeyOf(t) {
    return this.toKeyedSeq().reverse().keyOf(t);
  },
  max: function max(t) {
    return vn(this, t);
  },
  maxBy: function maxBy(t, e) {
    return vn(this, e, t);
  },
  min: function min(t) {
    return vn(this, t ? mo(t) : bo);
  },
  minBy: function minBy(t, e) {
    return vn(this, e ? mo(e) : bo, t);
  },
  rest: function rest() {
    return this.slice(1);
  },
  skip: function skip(t) {
    return 0 === t ? this : this.slice(Math.max(0, t));
  },
  skipLast: function skipLast(t) {
    return 0 === t ? this : this.slice(0, -Math.max(0, t));
  },
  skipWhile: function skipWhile(t, e) {
    return mn(this, hn(this, t, e, !0));
  },
  skipUntil: function skipUntil(t, e) {
    return this.skipWhile(go(t), e);
  },
  sortBy: function sortBy(t, e) {
    return mn(this, dn(this, e, t));
  },
  take: function take(t) {
    return this.slice(0, Math.max(0, t));
  },
  takeLast: function takeLast(t) {
    return this.slice(-Math.max(0, t));
  },
  takeWhile: function takeWhile(t, e) {
    return mn(this, function (t, e, r) {
      var n = wn(t);
      return n.__iterateUncached = function (n, i) {
        var o = this;
        if (i) return this.cacheResult().__iterate(n, i);
        var a = 0;
        return t.__iterate(function (t, i, s) {
          return e.call(r, t, i, s) && ++a && n(t, i, o);
        }), a;
      }, n.__iteratorUncached = function (n, i) {
        var o = this;
        if (i) return this.cacheResult().__iterator(n, i);

        var a = t.__iterator(pr, i),
            s = !0;

        return new vr(function () {
          if (!s) return {
            value: void 0,
            done: !0
          };
          var t = a.next();
          if (t.done) return t;
          var i = t.value,
              u = i[0],
              c = i[1];
          return e.call(r, c, u, o) ? n === pr ? t : yr(n, u, c, t) : (s = !1, {
            value: void 0,
            done: !0
          });
        });
      }, n;
    }(this, t, e));
  },
  takeUntil: function takeUntil(t, e) {
    return this.takeWhile(go(t), e);
  },
  update: function update(t) {
    return t(this);
  },
  valueSeq: function valueSeq() {
    return this.toIndexedSeq();
  },
  hashCode: function hashCode() {
    return this.__hash || (this.__hash = function (t) {
      if (t.size === 1 / 0) return 0;
      var e = ur(t),
          r = Je(t),
          n = e ? 1 : 0;
      return function (t, e) {
        return e = Ur(e, 3432918353), e = Ur(e << 15 | e >>> -15, 461845907), e = Ur(e << 13 | e >>> -13, 5), e = Ur((e = (e + 3864292196 | 0) ^ t) ^ e >>> 16, 2246822507), e = Vr((e = Ur(e ^ e >>> 13, 3266489909)) ^ e >>> 16);
      }(t.__iterate(r ? e ? function (t, e) {
        n = 31 * n + wo(Hr(t), Hr(e)) | 0;
      } : function (t, e) {
        n = n + wo(Hr(t), Hr(e)) | 0;
      } : e ? function (t) {
        n = 31 * n + Hr(t) | 0;
      } : function (t) {
        n = n + Hr(t) | 0;
      }), n);
    }(this));
  }
});
var lo = $e.prototype;
lo[Ke] = !0, lo[dr] = lo.values, lo.toJSON = lo.toArray, lo.__toStringMapper = zn, lo.inspect = lo.toSource = function () {
  return this.toString();
}, lo.chain = lo.flatMap, lo.contains = lo.includes, Xi(Qe, {
  flip: function flip() {
    return mn(this, sn(this));
  },
  mapEntries: function mapEntries(t, e) {
    var r = this,
        n = 0;
    return mn(this, this.toSeq().map(function (i, o) {
      return t.call(e, [o, i], n++, r);
    }).fromEntrySeq());
  },
  mapKeys: function mapKeys(t, e) {
    var r = this;
    return mn(this, this.toSeq().flip().map(function (n, i) {
      return t.call(e, n, i, r);
    }).flip());
  }
});
var po = Qe.prototype;
po[Ge] = !0, po[dr] = lo.entries, po.toJSON = co, po.__toStringMapper = function (t, e) {
  return zn(e) + ": " + zn(t);
}, Xi(tr, {
  toKeyedSeq: function toKeyedSeq() {
    return new rn(this, !1);
  },
  filter: function filter(t, e) {
    return mn(this, ln(this, t, e, !1));
  },
  findIndex: function findIndex(t, e) {
    var r = this.findEntry(t, e);
    return r ? r[0] : -1;
  },
  indexOf: function indexOf(t) {
    var e = this.keyOf(t);
    return void 0 === e ? -1 : e;
  },
  lastIndexOf: function lastIndexOf(t) {
    var e = this.lastKeyOf(t);
    return void 0 === e ? -1 : e;
  },
  reverse: function reverse() {
    return mn(this, cn(this, !1));
  },
  slice: function slice(t, e) {
    return mn(this, pn(this, t, e, !1));
  },
  splice: function splice(t, e) {
    var r = arguments.length;
    if (e = Math.max(e || 0, 0), 0 === r || 2 === r && !e) return this;
    t = Ue(t, t < 0 ? this.count() : this.size);
    var n = this.slice(0, t);
    return mn(this, 1 === r ? n : n.concat(En(arguments, 2), this.slice(t + e)));
  },
  findLastIndex: function findLastIndex(t, e) {
    var r = this.findLastEntry(t, e);
    return r ? r[0] : -1;
  },
  first: function first(t) {
    return this.get(0, t);
  },
  flatten: function flatten(t) {
    return mn(this, fn(this, t, !1));
  },
  get: function get(t, e) {
    return (t = qe(this, t)) < 0 || this.size === 1 / 0 || void 0 !== this.size && t > this.size ? e : this.find(function (e, r) {
      return r === t;
    }, void 0, e);
  },
  has: function has(t) {
    return (t = qe(this, t)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || t < this.size : -1 !== this.indexOf(t));
  },
  interpose: function interpose(t) {
    return mn(this, function (t, e) {
      var r = wn(t);
      return r.size = t.size && 2 * t.size - 1, r.__iterateUncached = function (r, n) {
        var i = this,
            o = 0;
        return t.__iterate(function (t) {
          return (!o || !1 !== r(e, o++, i)) && !1 !== r(t, o++, i);
        }, n), o;
      }, r.__iteratorUncached = function (r, n) {
        var i,
            o = t.__iterator(lr, n),
            a = 0;

        return new vr(function () {
          return (!i || a % 2) && (i = o.next()).done ? i : a % 2 ? yr(r, a++, e) : yr(r, a++, i.value, i);
        });
      }, r;
    }(this, t));
  },
  interleave: function interleave() {
    var t = [this].concat(En(arguments)),
        e = gn(this.toSeq(), kr.of, t),
        r = e.flatten(!0);
    return e.size && (r.size = e.size * t.length), mn(this, r);
  },
  keySeq: function keySeq() {
    return ao(0, this.size);
  },
  last: function last(t) {
    return this.get(-1, t);
  },
  skipWhile: function skipWhile(t, e) {
    return mn(this, hn(this, t, e, !1));
  },
  zip: function zip() {
    return mn(this, gn(this, _o, [this].concat(En(arguments))));
  },
  zipAll: function zipAll() {
    return mn(this, gn(this, _o, [this].concat(En(arguments)), !0));
  },
  zipWith: function zipWith(t) {
    var e = En(arguments);
    return e[0] = this, mn(this, gn(this, t, e));
  }
});
var ho = tr.prototype;

function fo(t, e, r, n, i, o) {
  return kn(t.size), t.__iterate(function (t, o, a) {
    i ? (i = !1, r = t) : r = e.call(n, r, t, o, a);
  }, o), r;
}

function vo(t, e) {
  return e;
}

function yo(t, e) {
  return [e, t];
}

function go(t) {
  return function () {
    return !t.apply(this, arguments);
  };
}

function mo(t) {
  return function () {
    return -t.apply(this, arguments);
  };
}

function _o() {
  return En(arguments);
}

function bo(t, e) {
  return t < e ? 1 : t > e ? -1 : 0;
}

function wo(t, e) {
  return t ^ e + 2654435769 + (t << 6) + (t >> 2) | 0;
}

ho[Ze] = !0, ho[sr] = !0, Xi(er, {
  get: function get(t, e) {
    return this.has(t) ? t : e;
  },
  includes: function includes(t) {
    return this.has(t);
  },
  keySeq: function keySeq() {
    return this.valueSeq();
  }
}), er.prototype.has = lo.includes, er.prototype.contains = er.prototype.includes, Xi(Ir, Qe.prototype), Xi(kr, tr.prototype), Xi(Lr, er.prototype);

var So = function (t) {
  function e(t) {
    return null == t ? ko() : Zi(t) ? t : ko().withMutations(function (e) {
      var r = er(t);
      kn(r.size), r.forEach(function (t) {
        return e.add(t);
      });
    });
  }

  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.of = function () {
    return this(arguments);
  }, e.fromKeys = function (t) {
    return this(Qe(t).keySeq());
  }, e.prototype.toString = function () {
    return this.__toString("OrderedSet {", "}");
  }, e;
}(Qi);

So.isOrderedSet = Zi;
var xo,
    Eo = So.prototype;

function Io(t, e) {
  var r = Object.create(Eo);
  return r.size = t ? t.size : 0, r._map = t, r.__ownerID = e, r;
}

function ko() {
  return xo || (xo = Io(qi()));
}

Eo[sr] = !0, Eo.zip = ho.zip, Eo.zipWith = ho.zipWith, Eo.__empty = ko, Eo.__make = Io;

var Lo = function Lo(t, e) {
  var r,
      n = function n(o) {
    var a = this;
    if (o instanceof n) return o;
    if (!(this instanceof n)) return new n(o);

    if (!r) {
      r = !0;
      var s = Object.keys(t),
          u = i._indices = {};
      i._name = e, i._keys = s, i._defaultValues = t;

      for (var c = 0; c < s.length; c++) {
        var l = s[c];
        u[l] = c, i[l] ? "object" == typeof console && console.warn && console.warn("Cannot define " + zo(this) + ' with property "' + l + '" since that property name is part of the Record API.') : Po(i, l);
      }
    }

    this.__ownerID = void 0, this._values = Si().withMutations(function (t) {
      t.setSize(a._keys.length), Qe(o).forEach(function (e, r) {
        t.set(a._indices[r], e === a._defaultValues[r] ? void 0 : e);
      });
    });
  },
      i = n.prototype = Object.create(Oo);

  return i.constructor = n, e && (n.displayName = e), n;
};

Lo.prototype.toString = function () {
  for (var t, e = zo(this) + " { ", r = this._keys, n = 0, i = r.length; n !== i; n++) {
    e += (n ? ", " : "") + (t = r[n]) + ": " + zn(this.get(t));
  }

  return e + " }";
}, Lo.prototype.equals = function (t) {
  return this === t || t && this._keys === t._keys && jo(this).equals(jo(t));
}, Lo.prototype.hashCode = function () {
  return jo(this).hashCode();
}, Lo.prototype.has = function (t) {
  return this._indices.hasOwnProperty(t);
}, Lo.prototype.get = function (t, e) {
  if (!this.has(t)) return e;

  var r = this._indices[t],
      n = this._values.get(r);

  return void 0 === n ? this._defaultValues[t] : n;
}, Lo.prototype.set = function (t, e) {
  if (this.has(t)) {
    var r = this._values.set(this._indices[t], e === this._defaultValues[t] ? void 0 : e);

    if (r !== this._values && !this.__ownerID) return To(this, r);
  }

  return this;
}, Lo.prototype.remove = function (t) {
  return this.set(t);
}, Lo.prototype.clear = function () {
  var t = this._values.clear().setSize(this._keys.length);

  return this.__ownerID ? this : To(this, t);
}, Lo.prototype.wasAltered = function () {
  return this._values.wasAltered();
}, Lo.prototype.toSeq = function () {
  return jo(this);
}, Lo.prototype.toJS = function () {
  return $i(this);
}, Lo.prototype.entries = function () {
  return this.__iterator(pr);
}, Lo.prototype.__iterator = function (t, e) {
  return jo(this).__iterator(t, e);
}, Lo.prototype.__iterate = function (t, e) {
  return jo(this).__iterate(t, e);
}, Lo.prototype.__ensureOwner = function (t) {
  if (t === this.__ownerID) return this;

  var e = this._values.__ensureOwner(t);

  return t ? To(this, e, t) : (this.__ownerID = t, this._values = e, this);
}, Lo.isRecord = or, Lo.getDescriptiveName = zo;
var Oo = Lo.prototype;

function To(t, e, r) {
  var n = Object.create(Object.getPrototypeOf(t));
  return n._values = e, n.__ownerID = r, n;
}

function zo(t) {
  return t.constructor.displayName || t.constructor.name || "Record";
}

function jo(t) {
  return Rr(t._keys.map(function (e) {
    return [e, t.get(e)];
  }));
}

function Po(t, e) {
  try {
    Object.defineProperty(t, e, {
      get: function get() {
        return this.get(e);
      },
      set: function set(t) {
        In(this.__ownerID, "Cannot set on an immutable record."), this.set(e, t);
      }
    });
  } catch (t) {}
}

function Ro(t, e) {
  return function t(e, r, n, i, o, a) {
    var s = Array.isArray(n) ? kr : On(n) ? Ir : null;

    if (s) {
      if (~e.indexOf(n)) throw new TypeError("Cannot convert circular structure to Immutable");
      e.push(n), o && "" !== i && o.push(i);
      var u = r.call(a, i, s(n).map(function (i, a) {
        return t(e, r, i, a, o, n);
      }), o && o.slice());
      return e.pop(), o && o.pop(), u;
    }

    return n;
  }([], e || Co, t, "", e && e.length > 2 ? [] : void 0, {
    "": t
  });
}

function Co(t, e) {
  return Je(e) ? e.toMap() : e.toList();
}

Oo[ir] = !0, Oo.delete = Oo.remove, Oo.deleteIn = Oo.removeIn = Mn, Oo.getIn = uo, Oo.hasIn = lo.hasIn, Oo.merge = Bn, Oo.mergeWith = Fn, Oo.mergeIn = Wn, Oo.mergeDeep = Hn, Oo.mergeDeepWith = Kn, Oo.mergeDeepIn = Gn, Oo.setIn = Cn, Oo.update = Dn, Oo.updateIn = qn, Oo.withMutations = Jn, Oo.asMutable = Zn, Oo.asImmutable = Yn, Oo[dr] = Oo.entries, Oo.toJSON = Oo.toObject = lo.toObject, Oo.inspect = Oo.toSource = function () {
  return this.toString();
};

var Mo = function Mo(t) {
  return t.map.module.temporalExtent;
},
    Ao = ze(function (t) {
  return t.map.tracks.data;
}, function (t) {
  return t.filter(function (t) {
    return void 0 !== t.data;
  });
}),
    Do = function Do(t, n) {
  return {
    sources: e({}, t.sources, {}, n.sources),
    layers: [].concat(r(t.layers), r(n.layers))
  };
},
    qo = function qo(t, r) {
  var n = r.start,
      i = r.end;
  if (!t || !t.features) return null;
  var o = t.features.reduce(function (t, r) {
    if (r.properties && r.properties.coordinateProperties && r.properties.coordinateProperties.times && r.properties.coordinateProperties.times.length > 0) {
      var o = r.geometry.coordinates.reduce(function (t, e, o) {
        var a = r.properties.coordinateProperties.times[o];
        return a >= n && a <= i && (t.coordinates.push(e), t.times.push(a)), t;
      }, {
        coordinates: [],
        times: []
      });
      if (!o.coordinates.length) return t;
      var a = e({}, r, {
        geometry: e({}, r.geometry, {
          coordinates: o.coordinates
        }),
        properties: e({}, r.properties, {
          coordinateProperties: {
            times: o.times
          }
        })
      });
      t.push(a);
    }

    return t;
  }, []);
  return e({}, t, {
    features: o
  });
},
    Bo = ze([Mo, Ao], function (e, r) {
  var n = e && e.length > 0,
      i = r && r.length > 0;
  if (!n || !i) return null;
  var o = {
    start: e[0].getTime(),
    end: e[1].getTime()
  };
  return r.reduce(function (e, r) {
    if (!r.data) return e;
    var n = "".concat(r.id, "Track"),
        i = {
      sources: t({}, n, {
        type: "geojson",
        data: qo(r.data, o)
      }),
      layers: [{
        id: "".concat(r.id, "Lines"),
        source: n,
        type: "line",
        paint: {
          "line-width": 1,
          "line-color": r.color
        }
      }, {
        id: "".concat(r.id, "Points"),
        source: n,
        type: "circle",
        filter: ["match", ["geometry-type"], ["", "Point"], !0, !1],
        paint: {
          "circle-radius": 4,
          "circle-color": r.color
        }
      }]
    };
    return Do(e, i);
  }, {
    sources: {},
    layers: []
  });
}),
    Fo = ze([function (t) {
  return t.map.module.highlightTemporalExtent;
}, Ao], function (e, r) {
  var n = e && e.length > 0,
      i = r && r.length > 0;
  if (!n || !i) return null;
  var o = {
    start: e[0].getTime(),
    end: e[1].getTime()
  };
  return r.reduce(function (e, r) {
    if (!r.data) return e;
    var n = "".concat(r.id, "HighlightedTrack"),
        i = {
      sources: t({}, n, {
        type: "geojson",
        data: qo(r.data, o)
      }),
      layers: [{
        id: "".concat(r.id, "HighlightedLines"),
        source: n,
        type: "line",
        paint: {
          "line-width": 1,
          "line-color": "#fff"
        }
      }]
    };
    return Do(e, i);
  }, {
    sources: {},
    layers: []
  });
}),
    Uo = ze([Bo, Fo], function (t, e) {
  return e ? Do(t, e) : t;
}),
    Vo = n(function (t, e) {
  function r(t, e, r) {
    void 0 === r && (r = {});
    var n = {
      type: "Feature"
    };
    return (0 === r.id || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = e || {}, n.geometry = t, n;
  }

  function n(t, e, n) {
    return void 0 === n && (n = {}), r({
      type: "Point",
      coordinates: t
    }, e, n);
  }

  function i(t, e, n) {
    void 0 === n && (n = {});

    for (var i = 0, o = t; i < o.length; i++) {
      var a = o[i];
      if (a.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");

      for (var s = 0; s < a[a.length - 1].length; s++) {
        if (a[a.length - 1][s] !== a[0][s]) throw new Error("First and last Position are not equivalent.");
      }
    }

    return r({
      type: "Polygon",
      coordinates: t
    }, e, n);
  }

  function o(t, e, n) {
    if (void 0 === n && (n = {}), t.length < 2) throw new Error("coordinates must be an array of two or more positions");
    return r({
      type: "LineString",
      coordinates: t
    }, e, n);
  }

  function a(t, e) {
    void 0 === e && (e = {});
    var r = {
      type: "FeatureCollection"
    };
    return e.id && (r.id = e.id), e.bbox && (r.bbox = e.bbox), r.features = t, r;
  }

  function s(t, e, n) {
    return void 0 === n && (n = {}), r({
      type: "MultiLineString",
      coordinates: t
    }, e, n);
  }

  function u(t, e, n) {
    return void 0 === n && (n = {}), r({
      type: "MultiPoint",
      coordinates: t
    }, e, n);
  }

  function c(t, e, n) {
    return void 0 === n && (n = {}), r({
      type: "MultiPolygon",
      coordinates: t
    }, e, n);
  }

  function l(t, r) {
    void 0 === r && (r = "kilometers");
    var n = e.factors[r];
    if (!n) throw new Error(r + " units is invalid");
    return t * n;
  }

  function p(t, r) {
    void 0 === r && (r = "kilometers");
    var n = e.factors[r];
    if (!n) throw new Error(r + " units is invalid");
    return t / n;
  }

  function h(t) {
    return 180 * (t % (2 * Math.PI)) / Math.PI;
  }

  function f(t) {
    return !isNaN(t) && null !== t && !Array.isArray(t) && !/^\s*$/.test(t);
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.earthRadius = 6371008.8, e.factors = {
    centimeters: 100 * e.earthRadius,
    centimetres: 100 * e.earthRadius,
    degrees: e.earthRadius / 111325,
    feet: 3.28084 * e.earthRadius,
    inches: 39.37 * e.earthRadius,
    kilometers: e.earthRadius / 1e3,
    kilometres: e.earthRadius / 1e3,
    meters: e.earthRadius,
    metres: e.earthRadius,
    miles: e.earthRadius / 1609.344,
    millimeters: 1e3 * e.earthRadius,
    millimetres: 1e3 * e.earthRadius,
    nauticalmiles: e.earthRadius / 1852,
    radians: 1,
    yards: e.earthRadius / 1.0936
  }, e.unitsFactors = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: .001,
    kilometres: .001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1e3,
    millimetres: 1e3,
    nauticalmiles: 1 / 1852,
    radians: 1 / e.earthRadius,
    yards: 1 / 1.0936
  }, e.areaFactors = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
  }, e.feature = r, e.geometry = function (t, e, r) {
    switch (t) {
      case "Point":
        return n(e).geometry;

      case "LineString":
        return o(e).geometry;

      case "Polygon":
        return i(e).geometry;

      case "MultiPoint":
        return u(e).geometry;

      case "MultiLineString":
        return s(e).geometry;

      case "MultiPolygon":
        return c(e).geometry;

      default:
        throw new Error(t + " is invalid");
    }
  }, e.point = n, e.points = function (t, e, r) {
    return void 0 === r && (r = {}), a(t.map(function (t) {
      return n(t, e);
    }), r);
  }, e.polygon = i, e.polygons = function (t, e, r) {
    return void 0 === r && (r = {}), a(t.map(function (t) {
      return i(t, e);
    }), r);
  }, e.lineString = o, e.lineStrings = function (t, e, r) {
    return void 0 === r && (r = {}), a(t.map(function (t) {
      return o(t, e);
    }), r);
  }, e.featureCollection = a, e.multiLineString = s, e.multiPoint = u, e.multiPolygon = c, e.geometryCollection = function (t, e, n) {
    return void 0 === n && (n = {}), r({
      type: "GeometryCollection",
      geometries: t
    }, e, n);
  }, e.round = function (t, e) {
    if (void 0 === e && (e = 0), e && !(e >= 0)) throw new Error("precision must be a positive number");
    var r = Math.pow(10, e || 0);
    return Math.round(t * r) / r;
  }, e.radiansToLength = l, e.lengthToRadians = p, e.lengthToDegrees = function (t, e) {
    return h(p(t, e));
  }, e.bearingToAzimuth = function (t) {
    var e = t % 360;
    return e < 0 && (e += 360), e;
  }, e.radiansToDegrees = h, e.degreesToRadians = function (t) {
    return t % 360 * Math.PI / 180;
  }, e.convertLength = function (t, e, r) {
    if (void 0 === e && (e = "kilometers"), void 0 === r && (r = "kilometers"), !(t >= 0)) throw new Error("length must be a positive number");
    return l(p(t, e), r);
  }, e.convertArea = function (t, r, n) {
    if (void 0 === r && (r = "meters"), void 0 === n && (n = "kilometers"), !(t >= 0)) throw new Error("area must be a positive number");
    var i = e.areaFactors[r];
    if (!i) throw new Error("invalid original units");
    var o = e.areaFactors[n];
    if (!o) throw new Error("invalid final units");
    return t / i * o;
  }, e.isNumber = f, e.isObject = function (t) {
    return !!t && t.constructor === Object;
  }, e.validateBBox = function (t) {
    if (!t) throw new Error("bbox is required");
    if (!Array.isArray(t)) throw new Error("bbox must be an Array");
    if (4 !== t.length && 6 !== t.length) throw new Error("bbox must be an Array of 4 or 6 numbers");
    t.forEach(function (t) {
      if (!f(t)) throw new Error("bbox must only contain numbers");
    });
  }, e.validateId = function (t) {
    if (!t) throw new Error("id is required");
    if (-1 === ["string", "number"].indexOf(typeof t)) throw new Error("id must be a number or a string");
  }, e.radians2degrees = function () {
    throw new Error("method has been renamed to `radiansToDegrees`");
  }, e.degrees2radians = function () {
    throw new Error("method has been renamed to `degreesToRadians`");
  }, e.distanceToDegrees = function () {
    throw new Error("method has been renamed to `lengthToDegrees`");
  }, e.distanceToRadians = function () {
    throw new Error("method has been renamed to `lengthToRadians`");
  }, e.radiansToDistance = function () {
    throw new Error("method has been renamed to `radiansToLength`");
  }, e.bearingToAngle = function () {
    throw new Error("method has been renamed to `bearingToAzimuth`");
  }, e.convertDistance = function () {
    throw new Error("method has been renamed to `convertLength`");
  };
});

i(Vo);
Vo.earthRadius, Vo.factors, Vo.unitsFactors, Vo.areaFactors, Vo.feature, Vo.geometry, Vo.point, Vo.points, Vo.polygon, Vo.polygons, Vo.lineString, Vo.lineStrings, Vo.featureCollection, Vo.multiLineString, Vo.multiPoint, Vo.multiPolygon, Vo.geometryCollection, Vo.round, Vo.radiansToLength, Vo.lengthToRadians, Vo.lengthToDegrees, Vo.bearingToAzimuth, Vo.radiansToDegrees, Vo.degreesToRadians, Vo.convertLength, Vo.convertArea, Vo.isNumber, Vo.isObject, Vo.validateBBox, Vo.validateId, Vo.radians2degrees, Vo.degrees2radians, Vo.distanceToDegrees, Vo.distanceToRadians, Vo.radiansToDistance, Vo.bearingToAngle, Vo.convertDistance;
var No = n(function (t, e) {
  function r(t, e, n) {
    if (null !== t) for (var i, o, a, s, u, c, l, p, h = 0, f = 0, d = t.type, v = "FeatureCollection" === d, y = "Feature" === d, g = v ? t.features.length : 1, m = 0; m < g; m++) {
      u = (p = !!(l = v ? t.features[m].geometry : y ? t.geometry : t) && "GeometryCollection" === l.type) ? l.geometries.length : 1;

      for (var _ = 0; _ < u; _++) {
        var b = 0,
            w = 0;

        if (null !== (s = p ? l.geometries[_] : l)) {
          c = s.coordinates;
          var S = s.type;

          switch (h = !n || "Polygon" !== S && "MultiPolygon" !== S ? 0 : 1, S) {
            case null:
              break;

            case "Point":
              if (!1 === e(c, f, m, b, w)) return !1;
              f++, b++;
              break;

            case "LineString":
            case "MultiPoint":
              for (i = 0; i < c.length; i++) {
                if (!1 === e(c[i], f, m, b, w)) return !1;
                f++, "MultiPoint" === S && b++;
              }

              "LineString" === S && b++;
              break;

            case "Polygon":
            case "MultiLineString":
              for (i = 0; i < c.length; i++) {
                for (o = 0; o < c[i].length - h; o++) {
                  if (!1 === e(c[i][o], f, m, b, w)) return !1;
                  f++;
                }

                "MultiLineString" === S && b++, "Polygon" === S && w++;
              }

              "Polygon" === S && b++;
              break;

            case "MultiPolygon":
              for (i = 0; i < c.length; i++) {
                for (w = 0, o = 0; o < c[i].length; o++) {
                  for (a = 0; a < c[i][o].length - h; a++) {
                    if (!1 === e(c[i][o][a], f, m, b, w)) return !1;
                    f++;
                  }

                  w++;
                }

                b++;
              }

              break;

            case "GeometryCollection":
              for (i = 0; i < s.geometries.length; i++) {
                if (!1 === r(s.geometries[i], e, n)) return !1;
              }

              break;

            default:
              throw new Error("Unknown Geometry Type");
          }
        }
      }
    }
  }

  function n(t, e) {
    var r;

    switch (t.type) {
      case "FeatureCollection":
        for (r = 0; r < t.features.length && !1 !== e(t.features[r].properties, r); r++) {
          ;
        }

        break;

      case "Feature":
        e(t.properties, 0);
    }
  }

  function i(t, e) {
    if ("Feature" === t.type) e(t, 0);else if ("FeatureCollection" === t.type) for (var r = 0; r < t.features.length && !1 !== e(t.features[r], r); r++) {
      ;
    }
  }

  function o(t, e) {
    var r,
        n,
        i,
        o,
        a,
        s,
        u,
        c,
        l,
        p,
        h = 0,
        f = "FeatureCollection" === t.type,
        d = "Feature" === t.type,
        v = f ? t.features.length : 1;

    for (r = 0; r < v; r++) {
      for (s = f ? t.features[r].geometry : d ? t.geometry : t, c = f ? t.features[r].properties : d ? t.properties : {}, l = f ? t.features[r].bbox : d ? t.bbox : void 0, p = f ? t.features[r].id : d ? t.id : void 0, a = (u = !!s && "GeometryCollection" === s.type) ? s.geometries.length : 1, i = 0; i < a; i++) {
        if (null !== (o = u ? s.geometries[i] : s)) switch (o.type) {
          case "Point":
          case "LineString":
          case "MultiPoint":
          case "Polygon":
          case "MultiLineString":
          case "MultiPolygon":
            if (!1 === e(o, h, c, l, p)) return !1;
            break;

          case "GeometryCollection":
            for (n = 0; n < o.geometries.length; n++) {
              if (!1 === e(o.geometries[n], h, c, l, p)) return !1;
            }

            break;

          default:
            throw new Error("Unknown Geometry Type");
        } else if (!1 === e(null, h, c, l, p)) return !1;
      }

      h++;
    }
  }

  function a(t, e) {
    o(t, function (t, r, n, i, o) {
      var a,
          s = null === t ? null : t.type;

      switch (s) {
        case null:
        case "Point":
        case "LineString":
        case "Polygon":
          return !1 !== e(Vo.feature(t, n, {
            bbox: i,
            id: o
          }), r, 0) && void 0;
      }

      switch (s) {
        case "MultiPoint":
          a = "Point";
          break;

        case "MultiLineString":
          a = "LineString";
          break;

        case "MultiPolygon":
          a = "Polygon";
      }

      for (var u = 0; u < t.coordinates.length; u++) {
        var c = {
          type: a,
          coordinates: t.coordinates[u]
        };
        if (!1 === e(Vo.feature(c, n), r, u)) return !1;
      }
    });
  }

  function s(t, e) {
    a(t, function (t, n, i) {
      var o = 0;

      if (t.geometry) {
        var a = t.geometry.type;

        if ("Point" !== a && "MultiPoint" !== a) {
          var s,
              u = 0,
              c = 0,
              l = 0;
          return !1 !== r(t, function (r, a, p, h, f) {
            if (void 0 === s || n > u || h > c || f > l) return s = r, u = n, c = h, l = f, void (o = 0);
            var d = Vo.lineString([s, r], t.properties);
            if (!1 === e(d, n, i, f, o)) return !1;
            o++, s = r;
          }) && void 0;
        }
      }
    });
  }

  function u(t, e) {
    if (!t) throw new Error("geojson is required");
    a(t, function (t, r, n) {
      if (null !== t.geometry) {
        var i = t.geometry.type,
            o = t.geometry.coordinates;

        switch (i) {
          case "LineString":
            if (!1 === e(t, r, n, 0, 0)) return !1;
            break;

          case "Polygon":
            for (var a = 0; a < o.length; a++) {
              if (!1 === e(Vo.lineString(o[a], t.properties), r, n, a)) return !1;
            }

        }
      }
    });
  }

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.coordEach = r, e.coordReduce = function (t, e, n, i) {
    var o = n;
    return r(t, function (t, r, i, a, s) {
      o = 0 === r && void 0 === n ? t : e(o, t, r, i, a, s);
    }, i), o;
  }, e.propEach = n, e.propReduce = function (t, e, r) {
    var i = r;
    return n(t, function (t, n) {
      i = 0 === n && void 0 === r ? t : e(i, t, n);
    }), i;
  }, e.featureEach = i, e.featureReduce = function (t, e, r) {
    var n = r;
    return i(t, function (t, i) {
      n = 0 === i && void 0 === r ? t : e(n, t, i);
    }), n;
  }, e.coordAll = function (t) {
    var e = [];
    return r(t, function (t) {
      e.push(t);
    }), e;
  }, e.geomEach = o, e.geomReduce = function (t, e, r) {
    var n = r;
    return o(t, function (t, i, o, a, s) {
      n = 0 === i && void 0 === r ? t : e(n, t, i, o, a, s);
    }), n;
  }, e.flattenEach = a, e.flattenReduce = function (t, e, r) {
    var n = r;
    return a(t, function (t, i, o) {
      n = 0 === i && 0 === o && void 0 === r ? t : e(n, t, i, o);
    }), n;
  }, e.segmentEach = s, e.segmentReduce = function (t, e, r) {
    var n = r,
        i = !1;
    return s(t, function (t, o, a, s, u) {
      n = !1 === i && void 0 === r ? t : e(n, t, o, a, s, u), i = !0;
    }), n;
  }, e.lineEach = u, e.lineReduce = function (t, e, r) {
    var n = r;
    return u(t, function (t, i, o, a) {
      n = 0 === i && void 0 === r ? t : e(n, t, i, o, a);
    }), n;
  }, e.findSegment = function (t, e) {
    if (e = e || {}, !Vo.isObject(e)) throw new Error("options is invalid");
    var r,
        n = e.featureIndex || 0,
        i = e.multiFeatureIndex || 0,
        o = e.geometryIndex || 0,
        a = e.segmentIndex || 0,
        s = e.properties;

    switch (t.type) {
      case "FeatureCollection":
        n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, r = t.features[n].geometry;
        break;

      case "Feature":
        s = s || t.properties, r = t.geometry;
        break;

      case "Point":
      case "MultiPoint":
        return null;

      case "LineString":
      case "Polygon":
      case "MultiLineString":
      case "MultiPolygon":
        r = t;
        break;

      default:
        throw new Error("geojson is invalid");
    }

    if (null === r) return null;
    var u = r.coordinates;

    switch (r.type) {
      case "Point":
      case "MultiPoint":
        return null;

      case "LineString":
        return a < 0 && (a = u.length + a - 1), Vo.lineString([u[a], u[a + 1]], s, e);

      case "Polygon":
        return o < 0 && (o = u.length + o), a < 0 && (a = u[o].length + a - 1), Vo.lineString([u[o][a], u[o][a + 1]], s, e);

      case "MultiLineString":
        return i < 0 && (i = u.length + i), a < 0 && (a = u[i].length + a - 1), Vo.lineString([u[i][a], u[i][a + 1]], s, e);

      case "MultiPolygon":
        return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), a < 0 && (a = u[i][o].length - a - 1), Vo.lineString([u[i][o][a], u[i][o][a + 1]], s, e);
    }

    throw new Error("geojson is invalid");
  }, e.findPoint = function (t, e) {
    if (e = e || {}, !Vo.isObject(e)) throw new Error("options is invalid");
    var r,
        n = e.featureIndex || 0,
        i = e.multiFeatureIndex || 0,
        o = e.geometryIndex || 0,
        a = e.coordIndex || 0,
        s = e.properties;

    switch (t.type) {
      case "FeatureCollection":
        n < 0 && (n = t.features.length + n), s = s || t.features[n].properties, r = t.features[n].geometry;
        break;

      case "Feature":
        s = s || t.properties, r = t.geometry;
        break;

      case "Point":
      case "MultiPoint":
        return null;

      case "LineString":
      case "Polygon":
      case "MultiLineString":
      case "MultiPolygon":
        r = t;
        break;

      default:
        throw new Error("geojson is invalid");
    }

    if (null === r) return null;
    var u = r.coordinates;

    switch (r.type) {
      case "Point":
        return Vo.point(u, s, e);

      case "MultiPoint":
        return i < 0 && (i = u.length + i), Vo.point(u[i], s, e);

      case "LineString":
        return a < 0 && (a = u.length + a), Vo.point(u[a], s, e);

      case "Polygon":
        return o < 0 && (o = u.length + o), a < 0 && (a = u[o].length + a), Vo.point(u[o][a], s, e);

      case "MultiLineString":
        return i < 0 && (i = u.length + i), a < 0 && (a = u[i].length + a), Vo.point(u[i][a], s, e);

      case "MultiPolygon":
        return i < 0 && (i = u.length + i), o < 0 && (o = u[i].length + o), a < 0 && (a = u[i][o].length - a), Vo.point(u[i][o][a], s, e);
    }

    throw new Error("geojson is invalid");
  };
});
i(No);
No.coordEach, No.coordReduce, No.propEach, No.propReduce, No.featureEach, No.featureReduce, No.coordAll, No.geomEach, No.geomReduce, No.flattenEach, No.flattenReduce, No.segmentEach, No.segmentReduce, No.lineEach, No.lineReduce, No.findSegment, No.findPoint;

var Ho = i(n(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = 6378137;

  function n(t) {
    var e = 0;

    if (t && t.length > 0) {
      e += Math.abs(i(t[0]));

      for (var r = 1; r < t.length; r++) {
        e -= Math.abs(i(t[r]));
      }
    }

    return e;
  }

  function i(t) {
    var e,
        n,
        i,
        a,
        s,
        u,
        c = 0,
        l = t.length;

    if (l > 2) {
      for (u = 0; u < l; u++) {
        u === l - 2 ? (i = l - 2, a = l - 1, s = 0) : u === l - 1 ? (i = l - 1, a = 0, s = 1) : (i = u, a = u + 1, s = u + 2), e = t[i], n = t[a], c += (o(t[s][0]) - o(e[0])) * Math.sin(o(n[1]));
      }

      c = c * r * r / 2;
    }

    return c;
  }

  function o(t) {
    return t * Math.PI / 180;
  }

  e.default = function (t) {
    return No.geomReduce(t, function (t, e) {
      return t + function (t) {
        var e,
            r = 0;

        switch (t.type) {
          case "Polygon":
            return n(t.coordinates);

          case "MultiPolygon":
            for (e = 0; e < t.coordinates.length; e++) {
              r += n(t.coordinates[e]);
            }

            return r;

          case "Point":
          case "MultiPoint":
          case "LineString":
          case "MultiLineString":
            return 0;
        }

        return 0;
      }(e);
    }, 0);
  };
})),
    Ko = "SET_MAP_CURSOR",
    Wo = function Wo(t) {
  var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
      r = e && void 0 !== e.metadata && void 0 !== e.metadata["gfw:popups"] ? e.metadata["gfw:popups"] : [],
      n = t.properties,
      i = Object.keys(t.properties).filter(function (t) {
    return 0 === r.length || void 0 !== r.find(function (e) {
      return e.id === t;
    });
  }).map(function (e) {
    var i = e === T ? function (t) {
      return (Math.pow(10, -6) * Ho(t.geometry)).toLocaleString("en-US", {
        maximumFractionDigits: 0
      });
    }(t) : n[e],
        o = r.find(function (t) {
      return t.id === e;
    }) || {},
        a = o.label || e;
    return {
      id: e,
      label: a,
      value: i,
      title: "".concat(a, ": ").concat(i),
      isLink: o.isLink,
      isMain: o.isMain
    };
  }),
      o = i.find(function (t) {
    return !0 === t.isMain;
  }) || i.find(function (t) {
    return "name" === t.id;
  }) || i.find(function (t) {
    return "id" === t.id;
  }) || i[0];
  return void 0 !== o && (o.isMain = !0), i;
},
    Go = function Go(t, e, r) {
  var n = {
    properties: t.properties
  },
      i = Wo(t, r);
  n.fields = i;
  var o = i.find(function (t) {
    return !0 === t.isMain;
  });
  return n.title = void 0 === o ? e : o.value, n;
},
    Jo = function Jo(t, r, n, i, o) {
  return function (a, s) {
    "click" === t && a(k());
    var u,
        c = s().map.style.mapStyle.toJS(),
        l = {
      latitude: r,
      longitude: n,
      features: []
    },
        p = s().map.heatmap.highlightedVessels;

    if (!0 !== p.isEmpty) {
      var h = void 0 === p.foundVessels ? [] : p.foundVessels,
          f = 0 === h.length ? [] : h[0],
          d = !0 === p.clickableCluster,
          v = !0 === d && !1 === p.highlightableCluster ? -1 : h.length;
      u = {
        isCluster: d,
        count: v,
        layer: {
          id: p.layer.id,
          group: "legacyHeatmap"
        },
        properties: f
      }, l.features.push(u);
    }

    var y = [];
    (i || []).forEach(function (t) {
      var r = function (t) {
        return void 0 !== t.layer.metadata && t.layer.metadata["gfw:id"] || t.layer.source;
      }(t),
          n = c.sources[r],
          i = e({
        layer: {
          id: r,
          group: t.layer.metadata && t.layer.metadata["mapbox:group"]
        }
      }, Go(t, r, n));

      if (!0 === t.properties.cluster) {
        var a = function (t, e) {
          var r = t.properties.cluster_id,
              n = e(t.source);
          return new Promise(function (e, i) {
            n.getClusterExpansionZoom(r, function (o, a) {
              n.getClusterLeaves(r, 99, 0, function (r, s) {
                (o || r) && i();
                var u = s.map(function (e) {
                  return Go(e, t.layer.id, n);
                });
                e({
                  zoom: a,
                  childrenFeatures: u
                });
              });
            });
          });
        }(t, o).then(function (t) {
          i.cluster = t, i.count = t.childrenFeatures.length;
        });

        y.push(a), i.isCluster = !0;
      } else i.isCluster = !1;

      l.features.push(i);
    }), Promise.all(y).then(function () {
      l.isCluster = l.features.length > 1 || l.features.some(function (t) {
        return !0 === t.isCluster;
      }), void 0 !== u && -1 === u.count ? l.count = -1 : l.count = l.features.reduce(function (t, e) {
        return t + (e.count || 1);
      }, 0), 1 === l.count && (l.feature = l.features[0]);
      var e = !0 === s().map.module.autoClusterZoom,
          i = s().map.module.isCluster(l);

      if (l.isCluster = i, e && "click" === t && !0 === l.isCluster) {
        a(L());
        var o = l.features[0].cluster && l.features[0].cluster.zoom;
        a(O(r, n, o));
      }

      var c = l.features.length ? "pointer" : null;
      !0 === l.isCluster && (c = "zoom-in"), a({
        type: Ko,
        payload: c
      });
      var p = "click" === t ? s().map.module.onClick : s().map.module.onHover;
      void 0 !== p && p(l);
    });
  };
},
    Zo = function () {
  function t(e, r, n) {
    var i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    a(this, t), this.stage = new PIXI.particles.ParticleContainer(z, {
      scale: !0,
      alpha: !0,
      position: !0,
      uvs: !0
    }), !1 === i && (this.stage.blendMode = PIXI.BLEND_MODES.SCREEN), this.spritesPool = [];
    var o = new PIXI.Rectangle(0, 0, 2 * j, 2 * j);
    this.mainVesselTexture = new PIXI.Texture(e, o), this._setTextureFrame(r, n), this.clearSpriteProps();
  }

  return o(t, [{
    key: "clearSpriteProps",
    value: function value() {
      this.spritesProps = {
        x: new Float32Array(z),
        y: new Float32Array(z),
        a: new Float32Array(z),
        s: new Float32Array(z)
      }, this.spritesPropsCount = 0;
    }
  }, {
    key: "pushSpriteProps",
    value: function value(t, e, r, n) {
      this.spritesProps.x[this.spritesPropsCount] = t, this.spritesProps.y[this.spritesPropsCount] = e, this.spritesProps.a[this.spritesPropsCount] = r, this.spritesProps.s[this.spritesPropsCount] = n, this.spritesPropsCount++;
    }
  }, {
    key: "setRenderingStyleIndex",
    value: function value(t) {
      this._setTextureFrame(t);
    }
  }, {
    key: "destroy",
    value: function value() {
      this.spritesPool = null, this.stage.destroy({
        children: !0
      });
    }
  }, {
    key: "_setTextureFrame",
    value: function value() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
          r = this.mainVesselTexture.frame.clone();

      if (null !== t && (r.x = 2 * j * t + t), null !== e) {
        var n = ve(e);
        n === ye - 1 && (n = 0), r.y = n * j * 2, n > 0 && (r.y += n);
      }

      this.mainVesselTexture.frame = r, this.mainVesselTexture.update();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.spritesPropsCount;
      this.resizeSpritesPool();

      for (var e = 0; e < t; e++) {
        var r = this.stage.children[e],
            n = this.spritesProps.s[e];
        r.setTransform(this.spritesProps.x[e], this.spritesProps.y[e], n, n), r.alpha = this.spritesProps.a[e];
      }

      for (var i = this.stage.children.length, o = t; o < i; o++) {
        this.stage.children[o].x = -100;
      }
    }
  }, {
    key: "resizeSpritesPool",
    value: function value() {
      var t = this.spritesPropsCount - this.stage.children.length;
      if (t < -4999) for (var e = Math.min(100, -t), r = 0; r < e; r++) {
        this.stage.removeChildAt(0);
      }

      if (t > 0) {
        var n = Math.max(5e3, t);

        this._addSprites(n);
      }
    }
  }, {
    key: "_addSprites",
    value: function value(t) {
      for (var e = 0; e < t; e++) {
        var r = new PIXI.Sprite(this.mainVesselTexture);
        r.anchor.x = .5, r.anchor.y = .5, r.x = -100, this.stage.addChild(r);
      }
    }
  }]), t;
}(),
    Yo = function Yo(t, e, r) {
  return [1 / 1.5 * (r[0] * t + r[4] * e + r[12]), 1 / 1.5 * (r[5] * e + r[13])];
},
    Xo = function (t) {
  function e() {
    return a(this, e), u(this, c(e).apply(this, arguments));
  }

  return s(e, t), o(e, [{
    key: "componentDidMount",
    value: function value() {
      this._build();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this._destroy();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this._redraw();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function value(t) {
      t.useRadialGradientStyle !== this.props.useRadialGradientStyle && this.setBrushZoomRenderingStyle(t.useRadialGradientStyle);
    }
  }, {
    key: "_build",
    value: function value() {
      var t = this.props,
          e = t.layer,
          r = t.rootStage,
          n = t.useRadialGradientStyle,
          i = t.customRenderingStyle;
      this.subLayers = {}, this.renderingStyle = e.header && e.header.rendering ? e.header.rendering : i, this.setBrushRenderingStyle(this.renderingStyle.style), this.setBrushZoomRenderingStyle(n), this.stage = new he(), r.addChild(this.stage);
    }
  }, {
    key: "setBrushRenderingStyle",
    value: function value() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : P.NORMAL;
      this.brushRenderingStyle = "string" == typeof t ? P[t.toUpperCase()] : t, this._setBrushRenderingStyleIndex();
    }
  }, {
    key: "setBrushZoomRenderingStyle",
    value: function value(t) {
      this.brushZoomRenderingStyle = !0 === t ? R.RADIAL_GRADIENT : R.CIRCLE, this._setBrushRenderingStyleIndex();
    }
  }, {
    key: "_setBrushRenderingStyleIndex",
    value: function value() {
      var t = this,
          e = this.brushRenderingStyle === P.NORMAL ? this.brushZoomRenderingStyle : 0,
          r = this.brushRenderingStyle + e;
      r !== this.renderingStyleIndex && (this.renderingStyleIndex = r, Object.values(this.subLayers).forEach(function (e) {
        e.setRenderingStyleIndex(t.renderingStyleIndex);
      }));
    }
  }, {
    key: "_redraw",
    value: function value() {
      var t = this,
          e = this.props,
          r = e.filters,
          n = e.baseTexture,
          i = e.layer;

      if (null != i && void 0 !== i.tiles && !1 !== i.visible) {
        this.stage.visible = !0, this.stage.alpha = i.opacity;

        for (var o = i.tiles, a = i.hue, s = void 0 !== r && r.length ? r.filter(function (t) {
          return !0 !== t.pass;
        }).map(function (t) {
          return void 0 === t.hue ? "0" : t.hue.toString();
        }) : [a.toString()], u = Object.keys(this.subLayers), c = C(s.concat(u)), l = 0; l < c.length; l++) {
          var p = c[l];
          -1 !== s.indexOf(p) ? (-1 === u.indexOf(p) && (this.subLayers[p] = this._createSublayer(n, this.renderingStyleIndex, p)), this.subLayers[p].clearSpriteProps()) : (this._destroySubLayer(this.subLayers[p]), delete this.subLayers[p]);
        }

        s.length && (o.forEach(function (e) {
          t._setSubLayersSpritePropsForTile({
            data: e.data,
            numFilters: r.length,
            defaultHue: a
          });
        }), s.forEach(function (e) {
          t.subLayers[e].render();
        }));
      } else this.stage.visible = !1;
    }
  }, {
    key: "_setSubLayersSpritePropsForTile",
    value: function value(t) {
      var e = t.data,
          r = t.numFilters,
          n = t.defaultHue;
      if (e) for (var i = this.props, o = i.startIndex, a = i.endIndex, s = i.viewport, u = i.filters, c = i.viewportLeft, p = i.viewportRight, h = o; h < a; h++) {
        var f = e[h];
        if (f) for (var d = 0, v = f.worldX.length; d < v; d++) {
          var y = void 0;
          void 0 !== u && u.length || (y = n);

          for (var g = 0; g < r; g++) {
            var m = u[g];

            if (M(f, d, m.filterValues)) {
              y = m.hue;
              break;
            }
          }

          if (void 0 !== y) {
            var _ = f.worldX[d];
            c > 0 && _ < c ? _ += 512 : c < 0 && _ > p && (_ -= 512);
            var b = _ * s.scale,
                w = f.worldY[d] * s.scale,
                S = s.pixelProjectionMatrix,
                x = 0 === s.pitch ? Yo(b, w, S) : A([b, w], S),
                E = l(x, 2),
                I = E[0],
                k = E[1];
            I > -10 && I < s.width + 10 && k > -10 && k < s.height + 10 && this.subLayers[y].pushSpriteProps(I, k, f.opacity ? f.opacity[d] : this.renderingStyle.defaultOpacity, f.radius ? f.radius[d] : this.renderingStyle.defaultSize);
          }
        }
      }
    }
  }, {
    key: "_createSublayer",
    value: function value(t, e, r) {
      var n = new Zo(t, e, r, this.brushRenderingStyle === P.BULLSEYE);
      return this.stage.addChild(n.stage), n;
    }
  }, {
    key: "_destroy",
    value: function value() {
      Object.values(this.subLayers).forEach(this._destroySubLayer.bind(this)), this.stage.destroy({
        children: !0
      }), this.props.rootStage.removeChild(this.stage);
    }
  }, {
    key: "_destroySubLayer",
    value: function value(t) {
      this.stage.removeChild(t.stage), t.destroy();
    }
  }, {
    key: "render",
    value: function value() {
      return null;
    }
  }]), e;
}(d.Component);

Xo.propTypes = {
  layer: y.object,
  rootStage: y.object,
  viewport: y.object,
  startIndex: y.number,
  endIndex: y.number,
  filters: y.array,
  baseTexture: y.object,
  useRadialGradientStyle: y.bool,
  customRenderingStyle: y.object,
  viewportLeft: y.number,
  viewportRight: y.number
};

var $o = function (r) {
  function n() {
    var e, r;
    a(this, n);

    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) {
      o[s] = arguments[s];
    }

    return r = u(this, (e = c(n)).call.apply(e, [this].concat(o))), t(p(r), "state", {
      pixiReady: !1
    }), t(p(r), "onTouchStart", function (t) {
      t.touches.length && r.queryCoords(t.touches[0].clientX, t.touches[0].clientY);
    }), t(p(r), "onMouseMove", function (t) {
      r.queryCoords(t.clientX, t.clientY);
    }), t(p(r), "_onTick", function () {
      !0 === r.heatmapFadingIn && r.heatmapStage.alpha < 1 && r._heatmapFadeinStep();
    }), r;
  }

  return s(n, ce), o(n, [{
    key: "componentDidMount",
    value: function value() {
      this._build(), this.setState({
        pixiReady: !0
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this._destroy();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function value(t) {
      this.props.exportNativeViewport(this._context.viewport), t.viewport.width === this.props.viewport.width && t.viewport.height === this.props.viewport.height || this._updateViewportSize(t.viewport.width, t.viewport.height);
    }
  }, {
    key: "_build",
    value: function value() {
      var t = this.props.viewport,
          e = t.width,
          r = t.height;
      this.pixi = new fe({
        width: e,
        height: r,
        transparent: !0,
        antialias: !0
      }), this.renderer = this.pixi.renderer, this.canvas = this.pixi.view, this.canvas.style.position = "absolute", this.container.appendChild(this.canvas), this.stage = this.pixi.stage;

      var n = function (t, e) {
        var r = document.createElement("canvas"),
            n = r.getContext("2d"),
            i = 2 * t;
        r.width = 3 * i + 2, r.height = i * ye + ye;

        for (var o = 0; o < ye; o++) {
          var a = i * o + o,
              s = a + t,
              u = t,
              c = n.createRadialGradient(u, s, t * e, u, s, t),
              l = be(o),
              p = ge(l);
          c.addColorStop(0, p);
          var h = me(_e(l + 30), 80, 100);
          c.addColorStop(1, "rgba(".concat(h.r, ", ").concat(h.g, ", ").concat(h.b, ", 0)")), n.fillStyle = c, n.fillRect(0, a, i, i), u += i + 1, n.beginPath(), n.arc(u, s, t, 0, 2 * Math.PI, !1), n.fillStyle = p, n.fill(), u += i + 1, n.beginPath(), n.arc(u, s, .4 * t, 0, 2 * Math.PI, !1), n.fillStyle = p, n.fill(), n.beginPath(), n.arc(u, s, .95 * t, 0, 2 * Math.PI, !1), n.lineWidth = 1, n.strokeStyle = p, n.stroke();
        }

        return r;
      }(j, F);

      this.baseTexture = de.fromCanvas(n), this.heatmapStage = new he(), this.stage.addChild(this.heatmapStage), this.pixi.ticker.add(this._onTick);
    }
  }, {
    key: "_destroy",
    value: function value() {
      this.pixi.destroy();
    }
  }, {
    key: "_updateViewportSize",
    value: function value(t, e) {
      this.renderer.resize(t, e);
    }
  }, {
    key: "toggleHeatmapDimming",
    value: function value(t) {
      void 0 !== this.heatmapStage && (!0 === t && (this.heatmapFadingIn = !1), this.heatmapStage.alpha = !0 === t ? D : 1);
    }
  }, {
    key: "queryCoords",
    value: function value(t, e) {
      if (!this.props.heatmapLayers.every(function (t) {
        return !0 !== t.interactive;
      })) {
        var r = this._context.viewport,
            n = r.unproject([t, e]),
            i = l(n, 2),
            o = i[0],
            a = i[1],
            s = o;
        s > 180 ? s -= 360 : s < -180 && (s += 360);
        var u = q([s, a], 1),
            c = l(u, 2),
            p = c[0],
            h = c[1],
            f = B / r.scale;
        this.props.queryHeatmapVessels({
          longitude: s,
          latitude: a,
          worldX: p,
          worldY: h,
          toleranceRadiusInWorldUnits: f
        }, this.props.temporalExtentIndexes);
      }
    }
  }, {
    key: "_startHeatmapFadein",
    value: function value() {
      this.heatmapFadingIn = !0, this.heatmapFadeinStartTimestamp = void 0;
    }
  }, {
    key: "_heatmapFadeinStep",
    value: function value() {
      void 0 === this.heatmapFadeinStartTimestamp && (this.heatmapFadeinStartTimestamp = Date.now());
      var t = (Date.now() - this.heatmapFadeinStartTimestamp) / 1e3,
          e = this.heatmapStage.alpha + (1 - this.heatmapStage.alpha) * t;
      e >= 1 && (e = 1, this.heatmapFadingIn = !1), this.heatmapStage.alpha = e;
    }
  }, {
    key: "_getHighlightData",
    value: function value(t, r, n) {
      var i = U,
          o = {
        id: "__HIGHLIGHT__",
        visible: !0,
        opacity: 1,
        hue: U
      },
          a = [];

      if (void 0 !== t && void 0 !== t.layer && void 0 !== t.foundVessels && !0 !== t.isEmpty) {
        var s = n.find(function (e) {
          return e.id === t.layer.id;
        });
        o = e({
          highlightLayerData: o
        }, s), a = t.foundVessels.map(function (t) {
          return {
            hue: i,
            filterValues: {
              series: [t.series]
            }
          };
        });
      } else if (null !== r) {
        var u = n.find(function (t) {
          return t.id === r.layer.id;
        });
        o = e({
          highlightLayerData: o
        }, u), a = [{
          hue: i,
          filterValues: {
            series: [r.id]
          }
        }];
      }

      return {
        highlightLayerData: o,
        highlightFilters: a
      };
    }
  }, {
    key: "_render",
    value: function value() {
      var t = this,
          e = this.props,
          r = e.zoom,
          n = e.heatmapLayers,
          i = e.temporalExtentIndexes,
          o = e.highlightedVessels,
          a = e.highlightedClickedVessel,
          s = e.leftWorldScaled,
          u = e.rightWorldScaled,
          c = this._context.viewport,
          l = this.state.pixiReady,
          p = i[0],
          h = i[1],
          f = function (t) {
        return t < V;
      }(r);

      if (!0 !== o.isEmpty && this.toggleHeatmapDimming(!0), !0 === o.isEmpty && this._startHeatmapFadein(), this.renderer && this.renderer.gl && void 0 !== this.renderer.gl.getError) {
        var y = this.renderer.gl.getError();
        0 !== y && console.log(y);
      }

      var g = this._getHighlightData(o, a, n),
          m = g.highlightLayerData,
          _ = g.highlightFilters;

      return d.createElement("div", {
        ref: function ref(e) {
          t.container = e;
        },
        style: {
          position: "absolute"
        },
        onMouseMove: this.onMouseMove,
        onTouchStart: this.onTouchStart
      }, !0 === l && d.createElement(v, null, n.map(function (e) {
        return d.createElement(Xo, {
          key: e.id,
          layer: e,
          filters: e.filters || [],
          viewport: c,
          startIndex: p,
          endIndex: h,
          baseTexture: t.baseTexture,
          rootStage: t.heatmapStage,
          useRadialGradientStyle: f,
          customRenderingStyle: {},
          viewportLeft: s,
          viewportRight: u
        });
      }), void 0 !== this.stage && d.createElement(Xo, {
        key: "highlighted",
        layer: m,
        filters: _,
        viewport: c,
        startIndex: p,
        endIndex: h,
        baseTexture: this.baseTexture,
        rootStage: this.heatmapStage,
        useRadialGradientStyle: f,
        customRenderingStyle: {
          defaultOpacity: 1,
          defaultSize: 1
        },
        viewportLeft: s,
        viewportRight: u
      })));
    }
  }]), n;
}();

$o.propTypes = {
  zoom: y.number,
  heatmapLayers: y.array,
  temporalExtentIndexes: y.array,
  highlightedVessels: y.object,
  highlightedClickedVessel: y.object,
  queryHeatmapVessels: y.func,
  exportNativeViewport: y.func,
  leftWorldScaled: y.number,
  rightWorldScaled: y.number
}, $o.contextTypes = {
  viewport: y.object
};
var Qo = ze([function (t) {
  return t.map.heatmap.heatmapLayers;
}], function (t) {
  return Object.keys(t).map(function (r) {
    return e({}, t[r]);
  });
}),
    ta = ze([Mo], function (t) {
  var e = t[0].getTime(),
      r = Math.max(t[1].getTime(), t[0].getTime() + N);
  return [H.getOffsetedTimeAtPrecision(e), H.getOffsetedTimeAtPrecision(r)];
}),
    ea = E(function (t) {
  return {
    highlightedVessels: t.map.heatmap.highlightedVessels,
    highlightedClickedVessel: t.map.heatmap.highlightedClickedVessel,
    viewport: t.map.viewport.viewport,
    zoom: t.map.viewport.viewport.zoom,
    heatmapLayers: Qo(t),
    leftWorldScaled: t.map.viewport.leftWorldScaled,
    rightWorldScaled: t.map.viewport.rightWorldScaled,
    temporalExtentIndexes: ta(t)
  };
}, function (t, e) {
  return {
    queryHeatmapVessels: function queryHeatmapVessels(e, r) {
      t(K(e, r));
    },
    exportNativeViewport: function exportNativeViewport(e) {
      t(W(e));
    }
  };
})($o),
    ra = "map_map__-6udN",
    na = "map_googleLogo__foP96";
g(".map_map__-6udN {\n  bottom: 0;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  z-index: 5;\n}\n\n.mapboxgl-ctrl-logo {\n  display: none;\n}\n\n/* Popup */\n\n.mapboxgl-popup-content {\n  background: none !important;\n  padding: 0 !important;\n}\n\n.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip {\n  border-top-color: #2b4f93 !important;\n}\n\n.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip,\n.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip {\n  border-bottom-color: #2b4f93 !important;\n}\n\n.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {\n  border-right-color: #2b4f93 !important;\n}\n\n.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {\n  border-left-color: #2b4f93 !important;\n}\n\n.mapboxgl-popup-close-button {\n  z-index: 1;\n  right: -18px;\n  top: 2px;\n  background-color: #fff;\n  border-radius: 50%;\n  cursor: pointer;\n  display: inline-block;\n  height: 20px;\n  position: absolute;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  color: #294480;\n  padding-bottom: 2px;\n  line-height: 0;\n  font-size: 16px;\n}\n\n.mapboxgl-popup-close-button:hover {\n  background-color: #fff;\n}\n\n.mapboxgl-popup-close-button:focus {\n  outline: none;\n}\n\n/* override Mapbox GL JS style to always show compact style */\n.mapboxgl-ctrl-attrib {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n  margin: 0 10px 10px 10px !important;\n  position: relative;\n  padding-right: 24px !important;\n  background-color: #fff !important;\n  border-radius: 3px 12px 12px 3px;\n  visibility: hidden;\n  z-index: 999;\n}\n\n.mapboxgl-ctrl-attrib:hover {\n  visibility: visible;\n}\n\n.mapboxgl-ctrl-attrib::after {\n  content: '';\n  cursor: pointer;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D%270%200%2020%2020%27%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%3E%0D%0A%09%3Cpath%20fill%3D%27%23333333%27%20fill-rule%3D%27evenodd%27%20d%3D%27M4%2C10a6%2C6%200%201%2C0%2012%2C0a6%2C6%200%201%2C0%20-12%2C0%20M9%2C7a1%2C1%200%201%2C0%202%2C0a1%2C1%200%201%2C0%20-2%2C0%20M9%2C10a1%2C1%200%201%2C1%202%2C0l0%2C3a1%2C1%200%201%2C1%20-2%2C0%27%20%2F%3E%0D%0A%3C%2Fsvg%3E');\n  background-color: rgba(255, 255, 255, 0.5);\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  visibility: visible;\n  border-radius: 12px;\n}\n\n@media screen and (min-width: 768px) {\n  .mapboxgl-ctrl-attrib,\n  .mapboxgl-ctrl-attrib::after {\n    display: none; /* use attribution of the footer */\n  }\n}\n\n.map_googleLogo__foP96 {\n  position: absolute;\n  left: 5px;\n  bottom: 5px;\n  width: 66px;\n  height: 26px;\n  cursor: pointer;\n  background-image: url('https://maps.gstatic.com/mapfiles/api-3/images/google4_hdpi.png');\n  background-size: cover;\n}\n");

var ia = function ia(t) {
  var e = t.latitude,
      r = t.longitude,
      n = t.children,
      i = t.closeButton,
      o = t.onClose;
  return d.createElement(le, {
    latitude: e,
    longitude: r,
    closeButton: i,
    onClose: o,
    anchor: "bottom",
    offsetTop: -10,
    tipSize: 4,
    closeOnClick: !1
  }, n);
};

ia.propTypes = {
  latitude: y.number.isRequired,
  longitude: y.number.isRequired,
  children: y.node.isRequired,
  closeButton: y.bool.isRequired,
  onClose: y.func
}, ia.defaultProps = {
  onClose: function onClose() {}
};

var oa = function (r) {
  function n(r) {
    var i;
    return a(this, n), i = u(this, c(n).call(this, r)), t(p(i), "onLoad", function () {
      void 0 !== i.props.onLoad && i.props.onLoad(i.getBounds());
    }), t(p(i), "setBounds", function () {
      var t = i.getBounds();
      null !== t && void 0 !== i.props.setBounds && i.props.setBounds(t);
    }), t(p(i), "getBounds", function () {
      if (!i.glMap) return null;
      var t = i.glMap.getBounds(),
          e = t._ne,
          r = t._sw;
      return {
        north: e.lat,
        south: r.lat,
        west: r.lng,
        east: e.lng
      };
    }), t(p(i), "loadObserver", h(_regeneratorRuntime.mark(function t() {
      var e;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if ("ResizeObserver" in window != !1) {
                t.next = 5;
                break;
              }

              return t.next = 3, import("./ResizeObserver.es-d777539c.js");

            case 3:
              e = t.sent, window.ResizeObserver = e.ResizeObserver || e.default;

            case 5:
              i._containerResizeObserver = new ResizeObserver(i.handleResizeObserver), i._containerResizeObserver.observe(i._mapContainerRef);

            case 7:
            case "end":
              return t.stop();
          }
        }
      }, t);
    }))), t(p(i), "handleResizeObserver", function (t) {
      var r = t[0].contentRect,
          n = r.width,
          o = r.height,
          a = i.props,
          s = a.viewport,
          u = a.setViewport;
      n === s.width && o === s.height || u(e({}, s, {
        width: n,
        height: o
      }));
    }), t(p(i), "onViewportChange", function (t, e) {
      var r = i.props.viewport;
      r.latitude === t.latitude && r.longitude === t.longitude && r.zoom === t.zoom && r.bearing === t.bearing && r.pitch === t.pitch || i.props.setViewport(t, e);
    }), t(p(i), "onMapInteraction", function (t, e) {
      i.props.mapInteraction(e, t.lngLat[1], t.lngLat[0], t.features, i.glGetSource);
    }), t(p(i), "onHover", function (t) {
      i.onMapInteraction(t, "hover");
    }), t(p(i), "onClick", function (t) {
      i.onMapInteraction(t, "click");
    }), t(p(i), "getRef", function (t) {
      null !== t && (i.glMap = t.getMap(), i.glGetSource = i.glMap.getSource.bind(i.glMap));
    }), t(p(i), "getCursor", function (t) {
      var e = t.isDragging,
          r = i.props.cursor;
      return null === r ? e ? "grabbing" : "grab" : r;
    }), t(p(i), "transformRequest", function (t, e) {
      var r = i.props.token;
      if (null !== r && "Tile" === e && t.match(G)) return {
        url: t,
        headers: {
          Authorization: "Bearer " + r
        }
      };
    }), i.state = {
      mouseOver: !0
    }, i._mapContainerRef = null, i;
  }

  return s(n, r), o(n, [{
    key: "componentDidMount",
    value: function value() {
      null !== this._mapContainerRef && this.loadObserver(), this.setBounds();
    }
  }, {
    key: "componentDidUpdate",
    value: function value() {
      this.setBounds();
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this._containerResizeObserver && this._containerResizeObserver.disconnect();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.props,
          r = e.viewport,
          n = e.maxZoom,
          i = e.minZoom,
          o = e.transitionEnd,
          a = e.mapStyle,
          s = e.onClosePopup,
          u = e.clickPopup,
          c = e.hoverPopup,
          l = e.hasHeatmapLayers,
          p = e.markers,
          h = e.interactiveLayerIds;
      return d.createElement("div", {
        id: "map",
        className: ra,
        ref: function ref(e) {
          t._mapContainerRef = e;
        },
        onMouseLeave: function onMouseLeave() {
          t.setState({
            mouseOver: !1
          });
        },
        onMouseEnter: function onMouseEnter() {
          t.setState({
            mouseOver: !0
          });
        }
      }, d.createElement(ue, f({}, r, {
        ref: this.getRef,
        transformRequest: this.transformRequest,
        onTransitionEnd: o,
        onLoad: this.onLoad,
        onHover: this.onHover,
        onClick: this.onClick,
        getCursor: this.getCursor,
        mapStyle: a,
        maxZoom: n,
        minZoom: i,
        onViewportChange: this.onViewportChange,
        interactiveLayerIds: h,
        clickRadius: 4,
        disableTokenWarning: !0
      }), !1 !== l && d.createElement(ea, null), null != u && d.createElement(ia, {
        latitude: u.latitude,
        longitude: u.longitude,
        closeButton: !0,
        onClose: s
      }, u.content), !0 === this.state.mouseOver && null != c && d.createElement(ia, {
        latitude: c.latitude,
        longitude: c.longitude,
        closeButton: !1
      }, c.content), null !== p && p.length > 0 && p.map(function (t, e) {
        return d.createElement(pe, {
          key: e,
          latitude: t.latitude,
          longitude: t.longitude
        }, t.content);
      })), d.createElement("div", {
        className: na
      }));
    }
  }]), n;
}(d.Component);

oa.propTypes = {
  token: y.string,
  viewport: y.object.isRequired,
  mapStyle: y.object.isRequired,
  clickPopup: y.object,
  hoverPopup: y.object,
  maxZoom: y.number.isRequired,
  minZoom: y.number.isRequired,
  setViewport: y.func.isRequired,
  setBounds: y.func,
  mapInteraction: y.func,
  onLoad: y.func,
  onClosePopup: y.func,
  transitionEnd: y.func,
  cursor: y.string,
  hasHeatmapLayers: y.bool.isRequired,
  markers: y.arrayOf(y.shape({
    latitude: y.number.isRequired,
    longitude: y.number.isRequired,
    content: y.node
  })),
  interactiveLayerIds: y.arrayOf(y.string)
}, oa.defaultProps = {
  token: null,
  clickPopup: null,
  hoverPopup: null,
  mapInteraction: function mapInteraction() {},
  onLoad: function onLoad() {},
  onClosePopup: function onClosePopup() {},
  transitionEnd: function transitionEnd() {},
  cursor: null,
  markers: null,
  interactiveLayerIds: null,
  setBounds: void 0
};

var aa,
    sa = ze([function (t) {
  return t.map.heatmap.heatmapLayers;
}], function (t) {
  return Object.keys(t).length > 0;
}),
    ua = ze([function (t) {
  return t.map.style.staticLayers;
}], function (t) {
  return t.reduce(function (t, e) {
    return e.interactive && e.visible ? (void 0 !== e.gl ? e.gl.layers.forEach(function (r, n) {
      if (1 === e.gl.layers.length || void 0 !== r.metadata && !0 === r.metadata["gfw:interactive"]) {
        var i = r.id || n > 0 ? "".concat(e.id, "-").concat(n) : e.id;
        t.push(i);
      }
    }) : t.push(e.id), t) : t;
  }, []);
}),
    ca = ze([function (t) {
  return t.map.style.mapStyle;
}, Uo], function (t, e) {
  if (!e) return t;
  var r = t.toJS().layers.filter(function (t) {
    return void 0 !== t.metadata;
  }).map(function (t) {
    return t.metadata["mapbox:group"];
  }).lastIndexOf(J) + 1,
      n = t.mergeIn(["sources"], e.sources),
      i = t.get("layers");
  return e.layers.forEach(function (t, e) {
    i = i.insert(r + e, Ro(t));
  }), n = n.set("layers", i);
}),
    la = ze([function (t) {
  return t.map.interaction.cursor;
}, function (t) {
  return t.map.module.cursor;
}], function (t, e) {
  return null !== e ? e : t;
}),
    pa = E(function (t) {
  return {
    viewport: t.map.viewport.viewport,
    maxZoom: t.map.viewport.maxZoom,
    minZoom: t.map.viewport.minZoom,
    onLoad: t.map.module.onLoad,
    cursor: la(t),
    token: t.map.module.token,
    mapStyle: ca(t),
    hasHeatmapLayers: sa(t),
    interactiveLayerIds: ua(t)
  };
}, function (t) {
  return {
    setViewport: function setViewport(e, r) {
      t(Z(e, r));
    },
    setBounds: function setBounds(e) {
      t(Y(e));
    },
    mapInteraction: function mapInteraction(e, r, n, i, o, a) {
      t(Jo(e, r, n, i, o));
    },
    transitionEnd: function transitionEnd() {
      t(X());
    },
    onClosePopup: function onClosePopup() {
      t($());
    }
  };
})(oa),
    ha = C(Object.keys(Se.sources).map(function (t) {
  return Se.sources[t].attribution;
}).filter(function (t) {
  return void 0 !== t;
})),
    fa = function fa(t) {
  if (void 0 === t.layout && (t.layout = {}), void 0 === t.paint && (t.paint = {}), void 0 === t.metadata && (t.metadata = {}), !0 === t.metadata["gfw:temporal"]) {
    var e = void 0 === t.metadata["gfw:temporalField"] ? "timestamp" : t.metadata["gfw:temporalField"];
    t.filter = ["all", [">", e, 0], ["<", e, 999999999999]];
  }

  return void 0 === t.metadata["mapbox:group"] && (t.metadata["mapbox:group"] = "temporal"), "visible" !== t.layout.visibility && (t.layout.visibility = "none"), t;
},
    da = {
  mapStyle: Ro((aa = Se, aa.layers.forEach(function (t) {
    fa(t);
  }), aa)),
  cartoLayersInstanciated: [],
  staticLayers: [],
  basemapLayers: [],
  attributions: ha
};

var va = [{
  gl: "line",
  geoJSON: ["LineString", "MultiLineString"]
}, {
  gl: "fill",
  geoJSON: ["Polygon", "MultiPolygon"]
}, {
  gl: "circle",
  geoJSON: ["Point", "MultiPoint"]
}],
    ya = "INIT_MAP_STYLE",
    ga = "SET_MAP_STYLE",
    ma = "MARK_CARTO_LAYERS_AS_INSTANCIATED",
    _a = "SET_STATIC_LAYERS",
    ba = "SET_BASEMAP_LAYERS",
    wa = function wa(t, n) {
  if ("vector" !== t.type) return t;
  var i = t.tiles,
      o = void 0 === n ? [] : [n],
      a = void 0 !== i && i.length > 0 ? C([].concat(o, r(i))) : o;
  return e({}, t, {
    tiles: a
  });
},
    Sa = function Sa(t) {
  return {
    type: ga,
    payload: t
  };
},
    xa = function xa(t, e, r) {
  for (var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], i = e().map.style.mapStyle, o = i.toJS().layers, a = Math.round(r[0].getTime() / 1e3), s = Math.round(r[1].getTime() / 1e3), u = H.getOffsetedTimeAtPrecision(r[0].getTime()), c = H.getOffsetedTimeAtPrecision(r[1].getTime()), l = 0; l < o.length; l++) {
    var p = o[l];

    if (void 0 !== p.metadata && !0 === p.metadata["gfw:temporal"] && !(!0 === n && !0 !== p.metadata["gfw:temporal:throttled"] || !1 === n && !0 === p.metadata["gfw:temporal:throttled"])) {
      var h = i.getIn(["layers", l, "filter"]).toJS();
      if (null === h) throw new Error("filter must be preset on style.json for temporal layer: ", p.id);
      var f = p.metadata && "timeIndex" === p.metadata["gfw:temporalField"];
      h[1][2] = f ? u : a, h[2][2] = f ? c : s, i = i.setIn(["layers", l, "filter"], Ro(h));
    }
  }

  t(Sa(i));
},
    Ea = S(function (t, e, r) {
  xa(t, e, r, !0);
}, 400),
    Ia = function Ia(t) {
  return function (e, r) {
    xa(e, r, t), Ea(e, r, t);
  };
},
    ka = function ka(t, r, n) {
  var i = t.toJS().layers,
      o = t,
      a = i.findIndex(function (t) {
    return t.id === r;
  }),
      s = i.find(function (t) {
    return t.id === r;
  });
  if (o = function (t, e, r) {
    var n = !0 === e.visible ? "visible" : "none";
    return t.setIn(["layers", r, "layout", "visibility"], n);
  }(o, n, a), !0 === n.isBasemap) return o;
  var u = void 0 === n.opacity ? 1 : n.opacity;

  switch (s.type) {
    case "fill":
      o = o.setIn(["layers", a, "paint", "fill-opacity"], u).setIn(["layers", a, "paint", "fill-outline-color"], n.color).setIn(["layers", a, "paint", "fill-color"], et);
      break;

    case "line":
      var c = n.color || s.paint && s.paint["line-color"];
      o = o.setIn(["layers", a, "paint", "line-opacity"], u).setIn(["layers", a, "paint", "line-color"], c);
      break;

    case "symbol":
      if (s.metadata && !0 === s.metadata["gfw:isLabel"]) {
        var l = "visible" === o.getIn(["layers", a, "layout", "visibility"]) && !0 === n.showLabels ? "visible" : "none";
        if (o = o.setIn(["layers", a, "layout", "visibility"], l), !0 !== n.showLabels) break;
      }

      o = o.setIn(["layers", a, "paint", "text-opacity"], u), void 0 !== n.color && (o = o.setIn(["layers", a, "paint", "text-color"], n.color));
      break;

    case "circle":
      if (o = o.setIn(["layers", a, "paint", "circle-opacity"], u).setIn(["layers", a, "paint", "circle-stroke-opacity"], u), void 0 !== n.color) {
        var p = s && s.metadata && s.metadata["gfw:mainColorPaintProperty"] ? s.metadata["gfw:mainColorPaintProperty"] : "circle-color";
        o = o.setIn(["layers", a, "paint", p], n.color);
      }

      break;

    case "raster":
      o = o.setIn(["layers", a, "paint", "raster-opacity"], u);
  }

  return o = function (t, r, n, i) {
    var o = t,
        a = t.toJS(),
        s = n.type,
        u = a.metadata["gfw:styles"],
        c = n.metadata;
    return ["selected", "highlighted"].forEach(function (t) {
      var a = r["".concat(t, "Features")],
          l = a && a.style ? a.style[s] : {},
          p = null != a && a.values.length > 0,
          h = r[t],
          f = u[t][s] || {},
          d = c && c["gfw:styles"] && c["gfw:styles"][t] || {},
          v = e({}, f, {}, d, {}, l);
      Object.keys(v).length && Object.keys(v).forEach(function (t) {
        var e,
            s = v[t][0],
            u = v[t][1],
            c = ["icon-size", "icon-image"].includes(t) ? "layout" : "paint";

        if (!1 === p && !0 !== h && !1 !== h) {
          var l = Se.layers.find(function (t) {
            return t.id === n.id;
          });
          e = void 0 !== l ? n.metadata && n.metadata["gfw:mainColorPaintProperty"] === t ? null : l[c][t] : null;
        } else if (!0 === h || !1 === h) e = !0 === h ? s : u;else {
          var f = "";

          if (null !== r.color && void 0 !== r.color) {
            var d = we(r.color);
            f = "".concat(d.r, ",").concat(d.g, ",").concat(d.b);
          }

          e = ["match", ["get", a.field], a.values, "string" != typeof s ? s : s.replace("$REFLAYER_COLOR_RGB", f), "string" != typeof u ? u : u.replace("$REFLAYER_COLOR_RGB", f)];
        }

        null != e && (o = o.setIn(["layers", i, c, t], e));
      });
    }), o;
  }(o, n, s, a);
},
    La = function La(t, e, r, n) {
  return function (i, o) {
    var a = o().map.style.mapStyle,
        s = a.toJS();

    if (void 0 === s.sources[e]) {
      var u = {
        type: t
      };
      t === Q.geojson ? u.data = n : t === Q.raster && (u.tiles = [r], u.tileSize = 256), a = a.setIn(["sources", e], Ro(u));
    }

    if (void 0 === s.layers.find(function (t) {
      return t.id === e;
    })) {
      var c = t === Q.geojson ? function (t) {
        var e = t.features.map(function (t) {
          var e = t.geometry;
          return void 0 === e ? null : e.type;
        }),
            r = va.map(function (t) {
          var r = 0;
          return e.forEach(function (e) {
            t.geoJSON.indexOf(e) > -1 && r++;
          }), {
            gl: t.gl,
            num: r
          };
        }),
            n = "fill",
            i = 0;
        return r.forEach(function (t) {
          t.num > i && (n = t.gl, i = t.num);
        }), n;
      }(n) : t,
          l = Ro({
        id: e,
        source: e,
        type: c,
        layout: {},
        paint: {}
      }),
          p = t === Q.raster ? s.layers.length - 1 - s.layers.filter(function (t) {
        return "labels" !== t.id;
      }).reverse().findIndex(function (t) {
        return "raster" === t.type;
      }) : s.layers.length - 1;
      a = a.set("layers", a.get("layers").splice(p, 0, l));
    }

    i(Sa(a));
  };
},
    Oa = function Oa(t) {
  return function (e, r) {
    e({
      type: ma,
      payload: t.map(function (t) {
        return t.sourceId;
      })
    });
    var n = t.map(function (t) {
      return r = (e = t).sourceId, n = e.sourceCartoSQL, i = {
        layers: [{
          id: r,
          options: {
            sql: n
          }
        }]
      }, o = encodeURIComponent(JSON.stringify(i)), a = rt.replace("$MAPCONFIG", o), new Promise(function (t) {
        fetch(a).then(function (t) {
          return t.status >= 400 ? (console.warn("loading of layer failed ".concat(r)), Promise.reject(), null) : t.json();
        }).then(function (e) {
          t({
            layergroupid: e.layergroupid,
            sourceId: r
          });
        }).catch(function (t) {
          console.warn(t);
        });
      });
      var e, r, n, i, o, a;
    });
    Promise.all(n.map(function (t) {
      return t.catch(function (t) {
        return t;
      });
    })).then(function (n) {
      var i = r().map.style.mapStyle,
          o = i.toJS();
      n.forEach(function (e) {
        var r = tt.replace("$LAYERGROUPID", e.layergroupid),
            n = "".concat(e.sourceId, "-instanciated");
        i = (i = i.setIn(["sources", n], Ro({
          type: "vector",
          tiles: [r]
        }))).deleteIn(["sources", e.sourceId]), o.layers.forEach(function (r, o) {
          if (r.source === e.sourceId) {
            i = (i = i.setIn(["layers", o, "source"], n)).setIn(["layers", o, "metadata", "gfw:id"], e.sourceId);
            var a = t.find(function (t) {
              return t.refLayer.id === e.sourceId;
            }).refLayer;
            i = ka(i, r.id, a);
          }
        });
      }), e(Sa(i));
    }).catch(function (t) {
      console.warn(t);
    });
  };
},
    Ta = function Ta(t, n) {
  return function (i, o) {
    i({
      type: _a,
      payload: t
    }), i({
      type: ba,
      payload: n
    });
    var a = [].concat(r(t), r(n.map(function (t) {
      return e({}, t, {
        isBasemap: !0
      });
    }))),
        s = o().map.style.mapStyle.toJS().sources,
        u = a.filter(function (t) {
      return void 0 !== t.gl;
    });
    u.length && i(function (t) {
      return function (r, n) {
        var i = n(),
            o = i.map.style.mapStyle;
        t.forEach(function (t) {
          var r = t.id,
              n = t.gl,
              i = wa(n.source, t.url),
              a = (o = o.setIn(["sources", r], Ro(i))).get("layers").toJS().map(function (t) {
            return t.id;
          });
          n.layers.filter(function (t, e) {
            var n = t.id || e > 0 ? "".concat(r, "-").concat(e) : r;
            return !a.includes(n);
          }).forEach(function (t, i) {
            var a = t.id || i > 0 ? "".concat(r, "-").concat(i) : r,
                s = fa(t),
                u = e({}, s, {
              id: a,
              source: r
            });

            if ("vector" === n.source.type) {
              var c = void 0 === t["source-layer"] ? r : t["source-layer"];
              u["source-layer"] = c;
            }

            var l = o.get("layers"),
                p = u.metadata["mapbox:group"],
                h = l.findLastIndex(function (t) {
              return p === t.toJS().metadata["mapbox:group"];
            });
            o = o.set("layers", l.splice(h, 0, Ro(u)));
          });
        }), r(Sa(o)), r(Ia(i.map.module.temporalExtent));
      };
    }(u));
    var c = a.filter(function (t) {
      return !0 === t.isCustom && void 0 === s[t.id];
    });
    c.length && c.forEach(function (t) {
      i(La(t.subtype, t.id, t.url, t.data));
    });
    var l = o().map.style,
        p = l.mapStyle,
        h = p.toJS(),
        f = h.layers,
        d = h.sources,
        v = [];
    t.forEach(function (t) {
      var e = t.id;

      if (void 0 !== s[e] && !0 === t.visible && (void 0 !== t.data && (p = p.setIn(["sources", e, "data"], Ro(t.data))), void 0 !== t.url)) {
        var r = wa(s[e], t.url);
        p = p.setIn(["sources", e], Ro(r));
      }
    });

    for (var y = function y(t) {
      var e = f[t],
          r = e.source,
          n = d[r],
          i = void 0 !== e.metadata && e.metadata["gfw:id"] || r,
          o = a.find(function (t) {
        return t.id === i;
      });
      if (void 0 === o) return e.type, "continue";
      var s = void 0 !== n.metadata && n.metadata["gfw:carto-sql"];

      if (!1 !== s && void 0 !== s) {
        var u = l.cartoLayersInstanciated.indexOf(r) > -1;
        return !0 !== o.visible || u || v.find(function (t) {
          return t.sourceId === r;
        }) || v.push({
          sourceId: r,
          sourceCartoSQL: s,
          refLayer: o
        }), "continue";
      }

      p = ka(p, e.id, o);
    }, g = 0; g < f.length; g++) {
      y(g);
    }

    v.length && i(Oa(v)), i(Sa(p));
  };
};

var za = function za(t, e) {
  for (var r = -1, n = null == t ? 0 : t.length; ++r < n && !1 !== e(t[r], r, t);) {
    ;
  }

  return t;
};

var ja = function ja(t, e) {
  return t && nt(e, it(e), t);
};

var Pa = function Pa(t, e) {
  return t && nt(e, ot(e), t);
},
    Ra = n(function (t, e) {
  var r = e && !e.nodeType && e,
      n = r && t && !t.nodeType && t,
      i = n && n.exports === r ? m.Buffer : void 0,
      o = i ? i.allocUnsafe : void 0;

  t.exports = function (t, e) {
    if (e) return t.slice();
    var r = t.length,
        n = o ? o(r) : new t.constructor(r);
    return t.copy(n), n;
  };
});

var Ca = function Ca(t, e) {
  return nt(t, at(t), e);
},
    Ma = Object.getOwnPropertySymbols ? function (t) {
  for (var e = []; t;) {
    ut(e, at(t)), t = ct(t);
  }

  return e;
} : st;

var Aa = function Aa(t, e) {
  return nt(t, Ma(t), e);
};

var Da = function Da(t) {
  return lt(t, ot, Ma);
},
    qa = Object.prototype.hasOwnProperty;

var Ba = function Ba(t) {
  var e = t.length,
      r = new t.constructor(e);
  return e && "string" == typeof t[0] && qa.call(t, "index") && (r.index = t.index, r.input = t.input), r;
};

var Fa = function Fa(t) {
  var e = new t.constructor(t.byteLength);
  return new pt(e).set(new pt(t)), e;
};

var Ua = function Ua(t, e) {
  var r = e ? Fa(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
},
    Va = /\w*$/;

var Na = function Na(t) {
  var e = new t.constructor(t.source, Va.exec(t));
  return e.lastIndex = t.lastIndex, e;
},
    Ha = _ ? _.prototype : void 0,
    Ka = Ha ? Ha.valueOf : void 0;

var Wa = function Wa(t) {
  return Ka ? Object(Ka.call(t)) : {};
};

var Ga = function Ga(t, e) {
  var r = e ? Fa(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
},
    Ja = "[object Boolean]",
    Za = "[object Date]",
    Ya = "[object Map]",
    Xa = "[object Number]",
    $a = "[object RegExp]",
    Qa = "[object Set]",
    ts = "[object String]",
    es = "[object Symbol]",
    rs = "[object ArrayBuffer]",
    ns = "[object DataView]",
    is = "[object Float32Array]",
    os = "[object Float64Array]",
    as = "[object Int8Array]",
    ss = "[object Int16Array]",
    us = "[object Int32Array]",
    cs = "[object Uint8Array]",
    ls = "[object Uint8ClampedArray]",
    ps = "[object Uint16Array]",
    hs = "[object Uint32Array]";

var fs = function fs(t, e, r) {
  var n = t.constructor;

  switch (e) {
    case rs:
      return Fa(t);

    case Ja:
    case Za:
      return new n(+t);

    case ns:
      return Ua(t, r);

    case is:
    case os:
    case as:
    case ss:
    case us:
    case cs:
    case ls:
    case ps:
    case hs:
      return Ga(t, r);

    case Ya:
      return new n();

    case Xa:
    case ts:
      return new n(t);

    case $a:
      return Na(t);

    case Qa:
      return new n();

    case es:
      return Wa(t);
  }
},
    ds = Object.create,
    vs = function () {
  function t() {}

  return function (e) {
    if (!b(e)) return {};
    if (ds) return ds(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();

var ys = function ys(t) {
  return "function" != typeof t.constructor || ht(t) ? {} : vs(ct(t));
},
    gs = "[object Map]";

var ms = function ms(t) {
  return w(t) && ft(t) == gs;
},
    _s = dt && dt.isMap,
    bs = _s ? vt(_s) : ms,
    ws = "[object Set]";

var Ss = function Ss(t) {
  return w(t) && ft(t) == ws;
},
    xs = dt && dt.isSet,
    Es = xs ? vt(xs) : Ss,
    Is = 1,
    ks = 2,
    Ls = 4,
    Os = "[object Arguments]",
    Ts = "[object Function]",
    zs = "[object GeneratorFunction]",
    js = "[object Object]",
    Ps = {};

Ps[Os] = Ps["[object Array]"] = Ps["[object ArrayBuffer]"] = Ps["[object DataView]"] = Ps["[object Boolean]"] = Ps["[object Date]"] = Ps["[object Float32Array]"] = Ps["[object Float64Array]"] = Ps["[object Int8Array]"] = Ps["[object Int16Array]"] = Ps["[object Int32Array]"] = Ps["[object Map]"] = Ps["[object Number]"] = Ps[js] = Ps["[object RegExp]"] = Ps["[object Set]"] = Ps["[object String]"] = Ps["[object Symbol]"] = Ps["[object Uint8Array]"] = Ps["[object Uint8ClampedArray]"] = Ps["[object Uint16Array]"] = Ps["[object Uint32Array]"] = !0, Ps["[object Error]"] = Ps[Ts] = Ps["[object WeakMap]"] = !1;

var Rs = function t(e, r, n, i, o, a) {
  var s,
      u = r & Is,
      c = r & ks,
      l = r & Ls;
  if (n && (s = o ? n(e, i, o, a) : n(e)), void 0 !== s) return s;
  if (!b(e)) return e;
  var p = bt(e);

  if (p) {
    if (s = Ba(e), !u) return yt(e, s);
  } else {
    var h = ft(e),
        f = h == Ts || h == zs;
    if (gt(e)) return Ra(e, u);

    if (h == js || h == Os || f && !o) {
      if (s = c || f ? {} : ys(e), !u) return c ? Aa(e, Pa(s, e)) : Ca(e, ja(s, e));
    } else {
      if (!Ps[h]) return o ? e : {};
      s = fs(e, h, u);
    }
  }

  a || (a = new mt());
  var d = a.get(e);
  if (d) return d;
  a.set(e, s), Es(e) ? e.forEach(function (i) {
    s.add(t(i, r, n, i, e, a));
  }) : bs(e) && e.forEach(function (i, o) {
    s.set(o, t(i, r, n, o, e, a));
  });
  var v = l ? c ? Da : _t : c ? keysIn : it,
      y = p ? void 0 : v(e);
  return za(y || e, function (i, o) {
    y && (i = e[o = i]), wt(s, o, t(i, r, n, o, e, a));
  }), s;
},
    Cs = 1,
    Ms = 4;

var As = function As(t) {
  return Rs(t, Cs | Ms);
},
    Ds = i(n(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = function (t) {
    var e = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
    return No.coordEach(t, function (t) {
      e[0] > t[0] && (e[0] = t[0]), e[1] > t[1] && (e[1] = t[1]), e[2] < t[0] && (e[2] = t[0]), e[3] < t[1] && (e[3] = t[1]);
    }), e;
  };
})),
    qs = function qs(t) {
  var e = {
    start: 1 / 0,
    end: 0
  };
  return t && t.features && t.features.forEach(function (t) {
    t.properties && t.properties.coordinateProperties && t.properties.coordinateProperties.times && t.properties.coordinateProperties.times.length > 0 && t.properties.coordinateProperties.times.forEach(function (t) {
      t < e.start ? e.start = t : t > e.end && (e.end = t);
    });
  }), [e.start, e.end];
},
    Bs = function Bs(t) {
  var e = Ds(t);
  return {
    minLat: e[3],
    minLng: e[0],
    maxLat: e[1],
    maxLng: e[2]
  };
},
    Fs = "ADD_TRACK",
    Us = "UPDATE_TRACK",
    Vs = function Vs(t) {
  for (var e, r = function r(t) {
    var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "track";
    return {
      type: "Feature",
      geometry: {
        type: arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "LineString",
        coordinates: []
      },
      properties: {
        type: e,
        segId: t,
        coordinateProperties: {
          times: []
        }
      }
    };
  }, n = t.series[0], i = r(n), o = r("fishing", "fishing", "MultiPoint"), a = [], s = 0, u = 0, c = t.latitude.length; u < c; u++) {
    var l = t.series[u],
        p = t.longitude[u],
        h = t.latitude[u],
        f = t.weight[u];
    e && (p - e < -180 ? s += 360 : p - e > 180 && (s -= 360));
    var d = [p + s, h];
    l !== n && 0 !== u && (a.push(As(i)), i = r(l)), i.geometry.coordinates.push(d), f > 0 && (o.geometry.coordinates.push(d), o.properties.coordinateProperties.times.push(t.datetime[u])), i.properties.coordinateProperties.times.push(t.datetime[u]), n = l, e = p;
  }

  return a.push(o), {
    type: "FeatureCollection",
    features: a
  };
};

var Ns,
    Hs = function Hs() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  return function (e, r) {
    var n = r().map.tracks.data;
    t && t.forEach(function (t) {
      var r,
          i = t.id,
          o = n.find(function (t) {
        return t.id === i;
      });
      void 0 === o ? e((r = t, function (t, e) {
        var n = r.id,
            i = r.url,
            o = r.type,
            a = r.fitBoundsOnLoad,
            s = r.layerTemporalExtents,
            u = r.color,
            c = r.data,
            l = e(),
            p = l.map.module.token;

        if (console.log("loadTrack -> token", p), !l.map.tracks.data.find(function (t) {
          return t.id === n;
        })) {
          var h = {
            id: n,
            url: i,
            type: o,
            color: u,
            fitBoundsOnLoad: a
          },
              f = void 0 !== r.data && null !== r.data,
              d = null != i && "" !== i;

          if (f && (h.data = c, h.geoBounds = Bs(c)), t({
            type: Fs,
            payload: h
          }), !f && d) {
            var v = St(t, l);

            if ("geojson" !== o) {
              var y = l.map.module.token,
                  g = xt(i, y, s);
              Promise.all(g.map(function (t) {
                return t.catch(function (t) {
                  return t;
                });
              })).then(function (e) {
                var r = Et(e);

                if (r.length) {
                  var i = It(r, ["latitude", "longitude", "datetime", "series", "weight", "sigma"]),
                      o = Vs(i),
                      a = qs(o),
                      s = Bs(o);
                  t({
                    type: Us,
                    payload: {
                      id: n,
                      data: o,
                      geoBounds: s,
                      timelineBounds: a
                    }
                  }), t(kt(v));
                }
              });
            } else fetch(i, {
              headers: {
                Authorization: "Bearer " + p
              }
            }).then(function (t) {
              if (t.status >= 400) throw new Error(t.statusText);
              return t.json();
            }).then(function (e) {
              var r = qs(e),
                  i = Bs(e);
              t({
                type: Us,
                payload: {
                  id: n,
                  data: e,
                  geoBounds: i,
                  timelineBounds: r
                }
              }), a && Lt(n);
            }).catch(function (t) {
              return console.warn(t);
            }).finally(function () {
              return t(kt(v));
            });
          }
        }
      })) : o.color !== t.color && e({
        type: Us,
        payload: {
          id: t.id,
          color: t.color
        }
      });
    }), n.forEach(function (r) {
      t && t.find(function (t) {
        return t.id === r.id;
      }) || e({
        type: "REMOVE_TRACK",
        payload: {
          trackId: r.id
        }
      });
    });
  };
},
    Ks = {
  loaders: null,
  token: void 0,
  temporalExtent: [new Date(1970), new Date()],
  highlightTemporalExtent: null,
  cursor: null,
  onViewportChange: void 0,
  onHover: void 0,
  onClick: void 0,
  onLoad: void 0,
  onLoadStart: void 0,
  onLoadComplete: void 0,
  onClosePopup: void 0,
  onAttributionsChange: void 0
},
    Ws = (y.arrayOf(y.number), y.string, y.arrayOf(y.instanceOf(Date)), y.func, y.func, y.func, y.func, y.func, y.func, y.func, y.func, Ns = function Ns() {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ks,
      n = arguments.length > 1 ? arguments[1] : void 0;

  switch (n.type) {
    case Rt:
      return e({}, t, {}, n.payload);

    case Pt:
      return e({}, t, {
        temporalExtent: n.payload
      });

    case jt:
      return e({}, t, {
        highlightTemporalExtent: n.payload
      });

    case zt:
      var i = null !== t.loaders ? r(t.loaders) : [];
      return i.push(n.payload), e({}, t, {
        loaders: i
      });

    case Tt:
      var o = r(t.loaders),
          a = o.findIndex(function (t) {
        return t === n.payload;
      });
      return o.splice(a, 1), e({}, t, {
        loaders: o
      });

    case Ot:
      return e({}, t, {
        cursor: n.payload
      });

    default:
      return t;
  }
}),
    Gs = {
  data: []
},
    Js = (y.arrayOf(y.exact(e({}, xe, {
  data: y.object,
  timelineBounds: y.array,
  geoBounds: y.exact({
    minLat: y.number,
    minLng: y.number,
    maxLat: y.number,
    maxLng: y.number
  })
}))), function (t) {
  return t;
}(function () {
  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Gs,
      n = arguments.length > 1 ? arguments[1] : void 0;

  switch (n.type) {
    case Fs:
      var i = [].concat(r(t.data), [n.payload]);
      return e({}, t, {
        data: i
      });

    case Us:
      var o = n.payload,
          a = t.data.map(function (t) {
        return t.id !== o.id ? t : e({}, t, {}, o);
      });
      return e({}, t, {
        data: a
      });

    case "REMOVE_TRACK":
      var s = n.payload.trackId,
          u = t.data.filter(function (t) {
        return t.id !== s;
      });
      return e({}, t, {
        data: u
      });

    default:
      return t;
  }
})),
    Zs = {
  heatmapLayers: {},
  referenceTiles: [],
  highlightedVessels: {
    isEmpty: !0
  },
  highlightedClickedVessel: null
};

var Ys = {
  currentVisibleTiles: [],
  currentLoadedTiles: [],
  currentToLoadTileUids: [],
  currentToReleaseTileUids: []
};
var Xs = {
  cursor: "progress"
};
var $s = x({
  module: Ws,
  tracks: Js,
  heatmap: function heatmap() {
    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Zs,
        i = arguments.length > 1 ? arguments[1] : void 0;

    switch (i.type) {
      case Wt:
        return Object.assign({}, n, {
          heatmapLayers: i.payload
        });

      case Ht:
        var o = n.heatmapLayers;
        return o[i.payload.layerId].visibleTemporalExtentsIndices = i.payload.newVisibleTemporalExtentsIndices, o[i.payload.layerId].tiles.forEach(function (t) {
          t.temporalExtentsIndicesLoaded = Kt(t.temporalExtentsIndicesLoaded, i.payload.indicesRemoved);
        }), e({}, n, {
          heatmapLayers: o
        });

      case Nt:
        var a = Object.assign({}, n.heatmapLayers, t({}, i.payload.id, e({
          tiles: []
        }, i.payload)));
        return Object.assign({}, n, {
          heatmapLayers: a
        });

      case Vt:
        var s = i.payload,
            u = e({}, n.heatmapLayers[s.id], {}, s),
            c = e({}, n.heatmapLayers, t({}, s.id, u));
        return e({}, n, {
          heatmapLayers: c
        });

      case Ut:
        var l = Object.assign({}, n.heatmapLayers);
        return delete l[i.payload.id], Object.assign({}, n, {
          heatmapLayers: l
        });

      case Ft:
        return Object.assign({}, n, {
          referenceTiles: [].concat(r(n.referenceTiles), [i.payload])
        });

      case Bt:
        var p = i.payload.layerId,
            h = i.payload.tile,
            f = e({}, n.heatmapLayers[p]),
            d = r(f.tiles),
            v = d.findIndex(function (t) {
          return t.uid === h.uid;
        });
        -1 === v ? d.push(h) : d = [].concat(r(d.slice(0, v)), [h], r(d.slice(v + 1))), f.tiles = d;
        var y = e({}, n.heatmapLayers, t({}, p, f));
        return e({}, n, {
          heatmapLayers: y
        });

      case qt:
        var g = i.payload,
            m = Object.keys(n.heatmapLayers),
            _ = e({}, n.heatmapLayers);

        m.forEach(function (t) {
          var r = e({}, _[t]);
          g.forEach(function (t) {
            var e = r.tiles.findIndex(function (e) {
              return e.uid === t;
            });
            e > -1 && r.tiles.splice(e, 1);
          });
        });
        var b = r(n.referenceTiles);
        return g.forEach(function (t) {
          var e = b.findIndex(function (e) {
            return e.uid === t;
          });
          e > -1 && (b = [].concat(r(b.slice(0, e)), r(b.slice(e + 1))));
        }), e({}, n, {
          heatmapLayers: _,
          referenceTiles: b
        });

      case Dt:
        var w = e({}, n.heatmapLayers);
        return e({}, n, {
          heatmapLayers: w
        });

      case At:
        return Object.assign({}, n, {
          highlightedVessels: i.payload
        });

      case Mt:
        return e({}, n, {
          highlightedClickedVessel: i.payload
        });

      case Ct:
        return e({}, n, {
          highlightedClickedVessel: null
        });

      default:
        return n;
    }
  },
  heatmapTiles: function heatmapTiles() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ys,
        r = arguments.length > 1 ? arguments[1] : void 0;

    switch (r.type) {
      case Xt:
        var n = [].concat(r.payload);
        return e({}, t, {
          currentVisibleTiles: n
        });

      case Yt:
        var i = [].concat(r.payload);
        return e({}, t, {
          currentLoadedTiles: i
        });

      case Zt:
        var o = C(t.currentToLoadTileUids.concat(r.payload.tilesToLoadUids)),
            a = C(t.currentToReleaseTileUids.concat(r.payload.tilesToReleaseUids)),
            s = o.filter(function (t) {
          return -1 === a.indexOf(t);
        });
        return e({}, t, {
          currentToLoadTileUids: s,
          currentToReleaseTileUids: a
        });

      case Jt:
        var u = t.currentToLoadTileUids,
            c = r.payload,
            l = u.filter(function (t) {
          return -1 === c.indexOf(t);
        });
        return e({}, t, {
          currentToLoadTileUids: l
        });

      case Gt:
        return e({}, t, {
          currentToReleaseTileUids: []
        });

      default:
        return t;
    }
  },
  style: function style() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : da,
        n = arguments.length > 1 ? arguments[1] : void 0;

    switch (n.type) {
      case ya:
        var i = t.mapStyle.setIn(["glyphs"], n.payload.glyphsPath);
        return e({}, t, {
          mapStyle: i
        });

      case ga:
        return e({}, t, {
          mapStyle: n.payload
        });

      case _a:
        return e({}, t, {
          staticLayers: n.payload
        });

      case ba:
        return e({}, t, {
          basemapLayers: n.payload
        });

      case ma:
        var o = [].concat(r(t.cartoLayersInstanciated), r(n.payload));
        return e({}, t, {
          cartoLayersInstanciated: o
        });

      default:
        return t;
    }
  },
  viewport: $t,
  interaction: function interaction() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Xs,
        r = arguments.length > 1 ? arguments[1] : void 0;

    switch (r.type) {
      case Ko:
        return e({}, t, {
          cursor: r.payload
        });

      default:
        return t;
    }
  }
}),
    Qs = x({
  map: $s
});
Qt.replaceReducer(Qs);

var tu = S(function (t) {
  Qt.dispatch(Ia(t)), Qt.dispatch(ae(t));
}, 16),
    eu = function eu(t) {
  Qt.dispatch(se({
    latitude: t.center[0],
    longitude: t.center[1],
    zoom: t.zoom
  }));
},
    ru = function (e) {
  function r() {
    var e, n;
    a(this, r);

    for (var i = arguments.length, o = new Array(i), s = 0; s < i; s++) {
      o[s] = arguments[s];
    }

    return n = u(this, (e = c(r)).call.apply(e, [this].concat(o))), t(p(n), "state", {
      initialized: !1,
      error: null,
      errorInfo: null
    }), n;
  }

  return s(r, e), o(r, [{
    key: "componentDidCatch",
    value: function value(t, e) {
      console.log(t, e), this.setState({
        error: t,
        errorInfo: e
      });
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      var t, e;
      void 0 !== this.props.viewport && eu(this.props.viewport), null !== this.props.glyphsPath && Qt.dispatch((t = {
        glyphsPath: this.props.glyphsPath
      }, e = t.glyphsPath, {
        type: ya,
        payload: {
          glyphsPath: e
        }
      })), void 0 !== this.props.onAttributionsChange && this.props.onAttributionsChange(Qt.getState().map.style.attributions), Qt && void 0 === Qt.getState().map.module.token && Qt.dispatch(te({
        token: this.props.token,
        autoClusterZoom: this.props.autoClusterZoom,
        isCluster: this.props.isCluster,
        onViewportChange: this.props.onViewportChange,
        onHover: this.props.onHover,
        onClick: this.props.onClick,
        onLoad: this.props.onLoad,
        onLoadStart: this.props.onLoadStart,
        onLoadComplete: this.props.onLoadComplete,
        onClosePopup: this.props.onClosePopup,
        onAttributionsChange: this.props.onAttributionsChange
      })), null !== this.props.highlightTemporalExtent && this.props.highlightTemporalExtent.length && Qt.dispatch(ee(this.props.highlightTemporalExtent)), (null !== this.props.basemapLayers && this.props.basemapLayers.length || null !== this.props.staticLayers && this.props.staticLayers.length) && Qt.dispatch(Ta(this.props.staticLayers || [], this.props.basemapLayers || [])), null !== this.props.tracks && Qt.dispatch(Hs(this.props.tracks)), null !== this.props.temporalExtent && this.props.temporalExtent.length && tu(this.props.temporalExtent), this.setState({
        initialized: !0
      }), null !== this.props.heatmapLayers && Qt.dispatch(re(this.props.heatmapLayers, this.props.loadTemporalExtent));
    }
  }, {
    key: "componentDidUpdate",
    value: function value(t) {
      this.props.tracks !== t.tracks && Qt.dispatch(Hs(this.props.tracks)), this.props.heatmapLayers !== t.heatmapLayers && Qt.dispatch(re(this.props.heatmapLayers, this.props.loadTemporalExtent)), (null !== this.props.basemapLayers && this.props.basemapLayers.length || null !== this.props.staticLayers && this.props.staticLayers.length) && (this.props.basemapLayers === t.basemapLayers && this.props.staticLayers === t.staticLayers || Qt.dispatch(Ta(this.props.staticLayers || [], this.props.basemapLayers || []))), null !== this.props.loadTemporalExtent && this.props.loadTemporalExtent.length && (null !== t.loadTemporalExtent && t.loadTemporalExtent.length && this.props.loadTemporalExtent[0].getTime() === t.loadTemporalExtent[0].getTime() && this.props.loadTemporalExtent[1].getTime() === t.loadTemporalExtent[1].getTime() || Qt.dispatch(ne(this.props.loadTemporalExtent))), null !== this.props.temporalExtent && this.props.temporalExtent.length && (null !== t.temporalExtent && t.temporalExtent.length && this.props.temporalExtent[0].getTime() === t.temporalExtent[0].getTime() && this.props.temporalExtent[1].getTime() === t.temporalExtent[1].getTime() || tu(this.props.temporalExtent)), null !== this.props.highlightTemporalExtent && this.props.highlightTemporalExtent.length ? null !== t.highlightTemporalExtent && t.highlightTemporalExtent.length && this.props.highlightTemporalExtent[0].getTime() === t.highlightTemporalExtent[0].getTime() && this.props.highlightTemporalExtent[1].getTime() === t.highlightTemporalExtent[1].getTime() || Qt.dispatch(ee(this.props.highlightTemporalExtent)) : this.props.highlightTemporalExtent !== t.highlightTemporalExtent && Qt.dispatch(ee(this.props.highlightTemporalExtent));
      var e = Qt.getState().map.viewport.viewport;
      void 0 !== this.props.viewport && null === Qt.getState().map.viewport.currentTransition && (e.latitude === this.props.viewport.center[0] && e.longitude === this.props.viewport.center[1] && e.zoom === this.props.viewport.zoom || (1 === Math.abs(e.zoom - this.props.viewport.zoom) ? Qt.dispatch(ie(this.props.viewport)) : eu(this.props.viewport))), this.props.cursor !== t.cursor && Qt.dispatch(oe(this.props.cursor));
    }
  }, {
    key: "render",
    value: function value() {
      return null !== this.state.error ? (console.log(this.state.error), d.createElement("div", null, d.createElement("h2", null, "Map component crashed!"), d.createElement("p", {
        className: "red"
      }, this.state.error && this.state.error.toString()), d.createElement("div", null, "Component Stack Error Details:"), d.createElement("p", {
        className: "red"
      }, this.state.errorInfo.componentStack))) : !0 !== this.state.initialized ? null : d.createElement(I, {
        store: Qt
      }, d.createElement(pa, this.props));
    }
  }]), r;
}(d.Component);

ru.propTypes = {
  token: y.string,
  viewport: y.shape(Oe).isRequired,
  autoClusterZoom: y.bool,
  isCluster: y.func,
  tracks: y.arrayOf(y.exact(xe)),
  heatmapLayers: y.arrayOf(y.shape(Ee)),
  temporalExtent: y.arrayOf(y.instanceOf(Date)),
  highlightTemporalExtent: y.arrayOf(y.instanceOf(Date)),
  loadTemporalExtent: y.arrayOf(y.instanceOf(Date)),
  basemapLayers: y.arrayOf(y.shape(Ie)),
  staticLayers: y.arrayOf(y.shape(ke)),
  cursor: y.string,
  hoverPopup: y.shape(Le),
  clickPopup: y.shape(Le),
  glyphsPath: y.string,
  onViewportChange: y.func,
  onLoad: y.func,
  onLoadStart: y.func,
  onLoadComplete: y.func,
  onClick: y.func,
  onHover: y.func,
  onAttributionsChange: y.func,
  onClosePopup: y.func
}, ru.defaultProps = {
  token: null,
  glyphsPath: null,
  autoClusterZoom: !0,
  isCluster: function isCluster(t) {
    return !0 === t.isCluster;
  },
  highlightTemporalExtent: null,
  tracks: null,
  hoverPopup: null,
  clickPopup: null,
  heatmapLayers: null,
  temporalExtent: null,
  loadTemporalExtent: null,
  basemapLayers: null,
  staticLayers: null,
  cursor: null,
  onViewportChange: function onViewportChange() {},
  onLoad: function onLoad() {},
  onLoadStart: function onLoadStart() {},
  onLoadComplete: function onLoadComplete() {},
  onClick: function onClick() {},
  onHover: function onHover() {},
  onAttributionsChange: function onAttributionsChange() {},
  onClosePopup: function onClosePopup() {}
};
export { ru as M, qs as a, Bs as g };